var Dr = function() {
};
const S = Dr;
var jr = function(o) {
  function e() {
    o.call(this), this._events = {};
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.bind = function(t, r, i) {
    var s = arguments, a = this, h = fe(t), p = ue(r), c = h.length;
    if (r === void 0) {
      for (var u in t)
        a.bind(u, t[u]);
      return this;
    }
    for (var f = function(v) {
      var g = h[v], _ = p ? r : r[g];
      if (_) {
        if (i) {
          var b = _;
          _ = function() {
            a.unbind(g, _), b.apply(a, s);
          }, _.original = b;
        }
        var x = a._events[g] = a._events[g] || [];
        x.push(_);
      }
    }, l = 0; l < c; l++)
      f(l);
    return this;
  }, e.prototype.one = function(t, r) {
    return this.bind(t, r, !0);
  }, e.prototype.first = function(t, r) {
    for (var i = this, s = fe(t), a = ue(r), h = 0, p = s.length; h < p; h++) {
      var c = s[h], u = a ? r : r[c];
      if (u) {
        var f = i._events[c] = i._events[c] || [];
        f.unshift(u);
      }
    }
    return this;
  }, e.prototype.trigger = function(t, r) {
    var i = this;
    r === void 0 && (r = {});
    var s = this._events[t];
    if (s) {
      var a = s.length;
      r.sender = this, r._defaultPrevented = !1, r.preventDefault = zr, r.isDefaultPrevented = Fr, s = s.slice();
      for (var h = 0; h < a; h++)
        s[h].call(i, r);
      return r._defaultPrevented === !0;
    }
    return !1;
  }, e.prototype.unbind = function(t, r) {
    var i = this._events[t];
    if (t === void 0)
      this._events = {};
    else if (i)
      if (r)
        for (var s = i.length - 1; s >= 0; s--)
          (i[s] === r || i[s].original === r) && i.splice(s, 1);
      else
        this._events[t] = [];
    return this;
  }, e;
}(S);
function ue(o) {
  return typeof o == "function";
}
function fe(o) {
  return typeof o == "string" ? [o] : o;
}
function zr() {
  this._defaultPrevented = !0;
}
function Fr() {
  return this._defaultPrevented === !0;
}
const Gr = jr;
var Ft = function(o) {
  var e = typeof window < "u" ? window : {}, n = e.requestAnimationFrame || e.webkitRequestAnimationFrame || e.mozRequestAnimationFrame || e.oRequestAnimationFrame || e.msRequestAnimationFrame || function(t) {
    setTimeout(t, 1e3 / 60);
  };
  Ft = function(t) {
    return n.call(e, t);
  }, Ft(o);
};
const qr = Ft;
var Br = /&/g, Hr = /</g, Nr = /"/g, Vr = /'/g, Ur = />/g;
function Gt(o) {
  return String(o).replace(Br, "&amp;").replace(Hr, "&lt;").replace(Ur, "&gt;").replace(Nr, "&quot;").replace(Vr, "&#39;");
}
function Xr(o) {
  var e = window.console;
  typeof e < "u" && e.log && e.log(o);
}
function Yr(o) {
  var e = {
    edge: /(edge)[ \/]([\w.]+)/i,
    webkit: /(chrome)[ \/]([\w.]+)/i,
    safari: /(webkit)[ \/]([\w.]+)/i,
    opera: /(opera)(?:.*version|)[ \/]([\w.]+)/i,
    msie: /(msie\s|trident.*? rv:)([\w.]+)/i,
    mozilla: /(mozilla)(?:.*? rv:([\w.]+))/i
  }, n = {};
  for (var t in e)
    if (e.hasOwnProperty(t)) {
      var r = o.match(e[t]);
      if (r) {
        n[t] = !0, n[r[1].toLowerCase().split(" ")[0].split("/")[0]] = !0, n.version = parseInt(document.documentMode || r[2], 10);
        break;
      }
    }
  return n;
}
var ft = null, Wr = {
  get browser() {
    return typeof window > "u" || ft || (ft = Yr(window.navigator.userAgent)), ft;
  }
};
const bt = Wr;
var Zr = Date.now || function() {
  return (/* @__PURE__ */ new Date()).getTime();
};
const qt = Zr;
function Jr(o, e) {
  var n = 0, t;
  if (!e || e <= 0)
    return o;
  var r = function() {
    var i = qt() - n, s = arguments, a = function() {
      o.apply(null, s), n = qt();
    };
    if (!n)
      return a();
    t && clearTimeout(t), i > e ? a() : t = setTimeout(a, e - i);
  };
  return r.cancel = function() {
    clearTimeout(t);
  }, r;
}
var Kr = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "00ffff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000000",
  blanchedalmond: "ffebcd",
  blue: "0000ff",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "00ffff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgrey: "a9a9a9",
  darkgreen: "006400",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "ff00ff",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  grey: "808080",
  green: "008000",
  greenyellow: "adff2f",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgrey: "d3d3d3",
  lightgreen: "90ee90",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "778899",
  lightslategrey: "778899",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "00ff00",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "ff00ff",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370d8",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "d87093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  red: "ff0000",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "ffffff",
  whitesmoke: "f5f5f5",
  yellow: "ffff00",
  yellowgreen: "9acd32"
};
const Zt = Kr;
var le = bt.browser, He = function(o) {
  var e = Object.keys(Zt);
  e.push("transparent");
  var n = new RegExp("^(" + e.join("|") + ")(\\W|$)", "i");
  return He = function(t) {
    return n.exec(t);
  }, n.exec(o);
}, Mt = function(o) {
  function e() {
    o.call(this);
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.toHSV = function() {
    return this;
  }, e.prototype.toRGB = function() {
    return this;
  }, e.prototype.toHex = function(t) {
    return this.toBytes().toHex(t);
  }, e.prototype.toBytes = function() {
    return this;
  }, e.prototype.toCss = function(t) {
    return "#" + this.toHex(t);
  }, e.prototype.toCssRgba = function() {
    var t = this.toBytes();
    return "rgba(" + t.r + ", " + t.g + ", " + t.b + ", " + parseFloat(Number(this.a).toFixed(3)) + ")";
  }, e.prototype.toDisplay = function() {
    return le.msie && le.version < 9 ? this.toCss() : this.toCssRgba();
  }, e.prototype.equals = function(t) {
    return t === this || t != null && this.toCssRgba() === Jt(t).toCssRgba();
  }, e.prototype.diff = function(t) {
    if (t === null)
      return NaN;
    var r = this.toBytes(), i = t.toBytes();
    return Math.sqrt(Math.pow((r.r - i.r) * 0.3, 2) + Math.pow((r.g - i.g) * 0.59, 2) + Math.pow((r.b - i.b) * 0.11, 2));
  }, e.prototype.clone = function() {
    var t = this.toBytes();
    return t === this && (t = new R(t.r, t.g, t.b, t.a)), t;
  }, e;
}(S), B = function(o) {
  function e(n, t, r, i) {
    o.call(this), this.r = n, this.g = t, this.b = r, this.a = i;
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.toHSV = function() {
    var t = this, r = t.r, i = t.g, s = t.b, a = Math.min(r, i, s), h = Math.max(r, i, s), p = h - a, c = h, u, f;
    return p === 0 ? new Bt(0, 0, c, this.a) : (h !== 0 ? (f = p / h, r === h ? u = (i - s) / p : i === h ? u = 2 + (s - r) / p : u = 4 + (r - i) / p, u *= 60, u < 0 && (u += 360)) : (f = 0, u = -1), new Bt(u, f, c, this.a));
  }, e.prototype.toHSL = function() {
    var t = this, r = t.r, i = t.g, s = t.b, a = Math.max(r, i, s), h = Math.min(r, i, s), p, c, u = (a + h) / 2;
    if (a === h)
      p = c = 0;
    else {
      var f = a - h;
      switch (c = u > 0.5 ? f / (2 - a - h) : f / (a + h), a) {
        case r:
          p = (i - s) / f + (i < s ? 6 : 0);
          break;
        case i:
          p = (s - r) / f + 2;
          break;
        case s:
          p = (r - i) / f + 4;
          break;
      }
    }
    return new Ne(p * 60, c * 100, u * 100, this.a);
  }, e.prototype.toBytes = function() {
    return new R(this.r * 255, this.g * 255, this.b * 255, this.a);
  }, e;
}(Mt), R = function(o) {
  function e(n, t, r, i) {
    o.call(this, Math.round(n), Math.round(t), Math.round(r), i);
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.toRGB = function() {
    return new o(this.r / 255, this.g / 255, this.b / 255, this.a);
  }, e.prototype.toHSV = function() {
    return this.toRGB().toHSV();
  }, e.prototype.toHSL = function() {
    return this.toRGB().toHSL();
  }, e.prototype.toHex = function(t) {
    var r = lt(this.r, 2) + lt(this.g, 2) + lt(this.b, 2);
    return t && t.alpha && (r += lt(Math.round(this.a * 255), 2)), r;
  }, e.prototype.toBytes = function() {
    return this;
  }, e;
}(B);
function lt(o, e, n) {
  n === void 0 && (n = "0");
  for (var t = o.toString(16); e > t.length; )
    t = n + t;
  return t;
}
var Bt = function(o) {
  function e(n, t, r, i) {
    o.call(this), this.h = n, this.s = t, this.v = r, this.a = i;
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.toRGB = function() {
    var t = this, r = t.h, i = t.s, s = t.v, a, h, p;
    if (i === 0)
      a = h = p = s;
    else {
      r /= 60;
      var c = Math.floor(r), u = r - c, f = s * (1 - i), l = s * (1 - i * u), v = s * (1 - i * (1 - u));
      switch (c) {
        case 0:
          a = s, h = v, p = f;
          break;
        case 1:
          a = l, h = s, p = f;
          break;
        case 2:
          a = f, h = s, p = v;
          break;
        case 3:
          a = f, h = l, p = s;
          break;
        case 4:
          a = v, h = f, p = s;
          break;
        default:
          a = s, h = f, p = l;
          break;
      }
    }
    return new B(a, h, p, this.a);
  }, e.prototype.toHSL = function() {
    return this.toRGB().toHSL();
  }, e.prototype.toBytes = function() {
    return this.toRGB().toBytes();
  }, e;
}(Mt), Ne = function(o) {
  function e(n, t, r, i) {
    o.call(this), this.h = n, this.s = t, this.l = r, this.a = i;
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.toRGB = function() {
    var t = this.h / 360, r = this.s / 100, i = this.l / 100, s, a, h;
    if (r === 0)
      s = a = h = i;
    else {
      var p = i < 0.5 ? i * (1 + r) : i + r - i * r, c = 2 * i - p;
      s = $t(c, p, t + 1 / 3), a = $t(c, p, t), h = $t(c, p, t - 1 / 3);
    }
    return new B(s, a, h, this.a);
  }, e.prototype.toHSV = function() {
    return this.toRGB().toHSV();
  }, e.prototype.toBytes = function() {
    return this.toRGB().toBytes();
  }, e;
}(Mt);
function $t(o, e, n) {
  var t = n;
  return t < 0 && (t += 1), t > 1 && (t -= 1), t < 1 / 6 ? o + (e - o) * 6 * t : t < 1 / 2 ? e : t < 2 / 3 ? o + (e - o) * (2 / 3 - t) * 6 : o;
}
function ve(o) {
  return parseFloat(parseFloat(parseInt(o, 16) / 255).toFixed(3));
}
function Jt(o, e) {
  var n, t;
  if (o == null || o === "none")
    return null;
  if (o instanceof Mt)
    return o;
  var r = o.toLowerCase();
  if (n = He(r))
    return n[1] === "transparent" ? r = new B(1, 1, 1, 0) : r = Jt(Zt[n[1]], e), r.match = [n[1]], r;
  if ((n = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})\b/i.exec(r)) ? t = new R(
    parseInt(n[1], 16),
    parseInt(n[2], 16),
    parseInt(n[3], 16),
    1
  ) : (n = /^#?([0-9a-f])([0-9a-f])([0-9a-f])\b/i.exec(r)) ? t = new R(
    parseInt(n[1] + n[1], 16),
    parseInt(n[2] + n[2], 16),
    parseInt(n[3] + n[3], 16),
    1
  ) : (n = /^#?([0-9a-f])([0-9a-f])([0-9a-f])([0-9a-f])\b/i.exec(r)) ? t = new R(
    parseInt(n[1] + n[1], 16),
    parseInt(n[2] + n[2], 16),
    parseInt(n[3] + n[3], 16),
    ve(n[4] + n[4])
  ) : (n = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})\b/i.exec(r)) ? t = new R(
    parseInt(n[1], 16),
    parseInt(n[2], 16),
    parseInt(n[3], 16),
    ve(n[4])
  ) : (n = /^rgb\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*\)/.exec(r)) ? t = new R(
    parseInt(n[1], 10),
    parseInt(n[2], 10),
    parseInt(n[3], 10),
    1
  ) : (n = /^rgba\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9.]+)\s*\)/.exec(r)) ? t = new R(
    parseInt(n[1], 10),
    parseInt(n[2], 10),
    parseInt(n[3], 10),
    parseFloat(n[4])
  ) : (n = /^rgb\(\s*([0-9]*\.?[0-9]+)%\s*,\s*([0-9]*\.?[0-9]+)%\s*,\s*([0-9]*\.?[0-9]+)%\s*\)/.exec(r)) ? t = new B(
    parseFloat(n[1]) / 100,
    parseFloat(n[2]) / 100,
    parseFloat(n[3]) / 100,
    1
  ) : (n = /^rgba\(\s*([0-9]*\.?[0-9]+)%\s*,\s*([0-9]*\.?[0-9]+)%\s*,\s*([0-9]*\.?[0-9]+)%\s*,\s*([0-9.]+)\s*\)/.exec(r)) && (t = new B(
    parseFloat(n[1]) / 100,
    parseFloat(n[2]) / 100,
    parseFloat(n[3]) / 100,
    parseFloat(n[4])
  )), t)
    t.match = n;
  else if (!e)
    throw new Error("Cannot parse color: " + r);
  return t;
}
var Qr = 180, Kt = function(o) {
  function e(n) {
    var t = this;
    if (o.call(this), arguments.length === 1)
      for (var r = e.formats, i = this.resolveColor(n), s = 0; s < r.length; s++) {
        var a = r[s].re, h = r[s].process, p = a.exec(i);
        if (p) {
          var c = h(p);
          t.r = c[0], t.g = c[1], t.b = c[2];
        }
      }
    else
      this.r = arguments[0], this.g = arguments[1], this.b = arguments[2];
    this.r = this.normalizeByte(this.r), this.g = this.normalizeByte(this.g), this.b = this.normalizeByte(this.b);
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.toHex = function() {
    var t = this.padDigit, r = this.r.toString(16), i = this.g.toString(16), s = this.b.toString(16);
    return "#" + t(r) + t(i) + t(s);
  }, e.prototype.resolveColor = function(t) {
    var r = t || "black";
    return r.charAt(0) === "#" && (r = r.substr(1, 6)), r = r.replace(/ /g, ""), r = r.toLowerCase(), r = e.namedColors[r] || r, r;
  }, e.prototype.normalizeByte = function(t) {
    return t < 0 || isNaN(t) ? 0 : t > 255 ? 255 : t;
  }, e.prototype.padDigit = function(t) {
    return t.length === 1 ? "0" + t : t;
  }, e.prototype.brightness = function(t) {
    var r = Math.round;
    return this.r = r(this.normalizeByte(this.r * t)), this.g = r(this.normalizeByte(this.g * t)), this.b = r(this.normalizeByte(this.b * t)), this;
  }, e.prototype.percBrightness = function() {
    return Math.sqrt(0.241 * this.r * this.r + 0.691 * this.g * this.g + 0.068 * this.b * this.b);
  }, e.prototype.isDark = function() {
    return this.percBrightness() < Qr;
  }, e.fromBytes = function(t, r, i, s) {
    return new R(t, r, i, s ?? 1);
  }, e.fromRGB = function(t, r, i, s) {
    return new B(t, r, i, s ?? 1);
  }, e.fromHSV = function(t, r, i, s) {
    return new Bt(t, r, i, s ?? 1);
  }, e.fromHSL = function(t, r, i, s) {
    return new Ne(t, r, i, s ?? 1);
  }, e;
}(S);
Kt.formats = [{
  re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
  process: function(o) {
    return [
      parseInt(o[1], 10),
      parseInt(o[2], 10),
      parseInt(o[3], 10)
    ];
  }
}, {
  re: /^(\w{2})(\w{2})(\w{2})$/,
  process: function(o) {
    return [
      parseInt(o[1], 16),
      parseInt(o[2], 16),
      parseInt(o[3], 16)
    ];
  }
}, {
  re: /^(\w{1})(\w{1})(\w{1})$/,
  process: function(o) {
    return [
      parseInt(o[1] + o[1], 16),
      parseInt(o[2] + o[2], 16),
      parseInt(o[3] + o[3], 16)
    ];
  }
}];
Kt.namedColors = Zt;
const Qi = Kt;
var tn = function(o) {
  function e() {
    o.apply(this, arguments);
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.observers = function() {
    return this._observers = this._observers || [], this._observers;
  }, e.prototype.addObserver = function(t) {
    return this._observers ? this._observers.push(t) : this._observers = [t], this;
  }, e.prototype.removeObserver = function(t) {
    var r = this.observers(), i = r.indexOf(t);
    return i !== -1 && r.splice(i, 1), this;
  }, e.prototype.trigger = function(t, r) {
    var i = this._observers;
    if (i && !this._suspended)
      for (var s = 0; s < i.length; s++) {
        var a = i[s];
        a[t] && a[t](r);
      }
    return this;
  }, e.prototype.optionsChange = function(t) {
    t === void 0 && (t = {}), t.element = this, this.trigger("optionsChange", t);
  }, e.prototype.geometryChange = function() {
    this.trigger("geometryChange", {
      element: this
    });
  }, e.prototype.suspend = function() {
    return this._suspended = (this._suspended || 0) + 1, this;
  }, e.prototype.resume = function() {
    return this._suspended = Math.max((this._suspended || 0) - 1, 0), this;
  }, e.prototype._observerField = function(t, r) {
    this[t] && this[t].removeObserver(this), this[t] = r, r.addObserver(this);
  }, e;
}(S);
const E = tn;
function nt(o, e) {
  return o.push.apply(o, e), o;
}
var en = {
  1: "i",
  10: "x",
  100: "c",
  2: "ii",
  20: "xx",
  200: "cc",
  3: "iii",
  30: "xxx",
  300: "ccc",
  4: "iv",
  40: "xl",
  400: "cd",
  5: "v",
  50: "l",
  500: "d",
  6: "vi",
  60: "lx",
  600: "dc",
  7: "vii",
  70: "lxx",
  700: "dcc",
  8: "viii",
  80: "lxxx",
  800: "dccc",
  9: "ix",
  90: "xc",
  900: "cm",
  1e3: "m"
};
function rn(o) {
  for (var e = [
    1e3,
    900,
    800,
    700,
    600,
    500,
    400,
    300,
    200,
    100,
    90,
    80,
    70,
    60,
    50,
    40,
    30,
    20,
    10,
    9,
    8,
    7,
    6,
    5,
    4,
    3,
    2,
    1
  ], n = ""; o > 0; )
    o < e[0] ? e.shift() : (n += en[e[0]], o -= e[0]);
  return n;
}
function wt() {
  var o, e, n = new Promise(function(t, r) {
    o = function(i) {
      return n._state = "resolved", t(i), n;
    }, e = function(i) {
      return n._state = "rejected", r(i), n;
    };
  });
  return n._state = "pending", n.resolve = o, n.reject = e, n.state = function() {
    return n._state;
  }, n;
}
var nn = "undefined";
function d(o) {
  return typeof o !== nn;
}
var on = 1;
function xt() {
  return "kdef" + on++;
}
var Qt = Math.PI / 180, Z = Number.MAX_VALUE, J = -Number.MAX_VALUE;
function F(o) {
  return o / Qt;
}
var A = String.fromCharCode, ts = "þÿ";
function sn(o) {
  for (var e = "", n = 0; n < o.length; n++) {
    var t = o.charCodeAt(n);
    if (55296 <= t && t <= 56319) {
      var r = t, i = o.charCodeAt(++n);
      isNaN(i) || (t = (r - 55296) * 1024 + (i - 56320) + 65536);
    }
    t < 128 ? e += A(t) : t < 2048 ? (e += A(192 | t >>> 6), e += A(128 | t & 63)) : t < 65536 ? (e += A(224 | t >>> 12), e += A(128 | t >>> 6 & 63), e += A(128 | t & 63)) : t < 1114111 && (e += A(240 | t >>> 18), e += A(128 | t >>> 12 & 63), e += A(128 | t >>> 6 & 63), e += A(128 | t & 63));
  }
  return e;
}
function Pt(o) {
  return A(o >> 8) + A(o & 255);
}
function es(o) {
  for (var e = "", n = 0; n < o.length; n++) {
    var t = o.charCodeAt(n);
    if (t < 65535)
      e += Pt(t);
    else {
      var r = (t - 65536 >> 10) + 55296, i = (t - 65536 & 1023) + 56320;
      e += Pt(r), e += Pt(i);
    }
  }
  return e;
}
var vt = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
function an(o) {
  for (var e = "", n = 0, t = sn(o); n < t.length; ) {
    var r = t.charCodeAt(n++), i = t.charCodeAt(n++), s = t.charCodeAt(n++), a = r >> 2, h = (r & 3) << 4 | i >> 4, p = (i & 15) << 2 | s >> 6, c = s & 63;
    isNaN(i) ? p = c = 64 : isNaN(s) && (c = 64), e = e + vt.charAt(a) + vt.charAt(h) + vt.charAt(p) + vt.charAt(c);
  }
  return e;
}
function Ve(o) {
  return d((o.x || {}).location) ? {
    x: o.x.location,
    y: o.y.location
  } : {
    x: o.pageX || o.clientX || 0,
    y: o.pageY || o.clientY || 0
  };
}
function Ue(o) {
  return o === void 0 && (o = {}), o.touch ? o.touch.initialTouch : o.target;
}
function N(o) {
  return o === "" || o === null || o === "none" || o === "transparent" || !d(o);
}
function w(o) {
  if (o)
    return o[o.length - 1];
}
function Ht(o, e, n) {
  return Math.max(Math.min(o, n), e);
}
function hn(o, e) {
  if (o.length < 2)
    return o.slice();
  function n(t, r) {
    for (var i = [], s = 0, a = 0, h = 0; s < t.length && a < r.length; )
      e(t[s], r[a]) <= 0 ? i[h++] = t[s++] : i[h++] = r[a++];
    return s < t.length && i.push.apply(i, t.slice(s)), a < r.length && i.push.apply(i, r.slice(a)), i;
  }
  return function t(r) {
    if (r.length <= 1)
      return r;
    var i = Math.floor(r.length / 2), s = r.slice(0, i), a = r.slice(i);
    return s = t(s), a = t(a), n(s, a);
  }(o);
}
function Xe(o) {
  return Promise.all(o);
}
function $(o) {
  return o * Qt;
}
function pn(o) {
  return o ? Math.pow(10, o) : 1;
}
function m(o, e) {
  var n = pn(e);
  return Math.round(o * n) / n;
}
function te(o, e) {
  return d(o) ? o : e;
}
function ee(o, e) {
  for (var n in e)
    for (var t = n.trim().split(" "), r = 0; r < t.length; r++)
      o.addEventListener(t[r], e[n], !1);
}
function Ye(o) {
  var e = o.getBoundingClientRect(), n = document.documentElement;
  return {
    top: e.top + (window.pageYOffset || n.scrollTop) - (n.clientTop || 0),
    left: e.left + (window.pageXOffset || n.scrollLeft) - (n.clientLeft || 0)
  };
}
function Et(o, e) {
  for (var n = {}, t = window.getComputedStyle(o) || {}, r = Array.isArray(e) ? e : [e], i = 0; i < r.length; i++) {
    var s = r[i];
    n[s] = t[s];
  }
  return n;
}
function ye(o) {
  return isNaN(o) ? o : o + "px";
}
function et(o, e) {
  if (e) {
    var n = e.width, t = e.height;
    d(n) && (o.style.width = ye(n)), d(t) && (o.style.height = ye(t));
  } else {
    var r = Et(o, ["width", "height"]);
    return {
      width: parseInt(r.width, 10),
      height: parseInt(r.height, 10)
    };
  }
}
function re(o, e) {
  e === void 0 && (e = {});
  for (var n in e)
    for (var t = n.trim().split(" "), r = 0; r < t.length; r++)
      o.removeEventListener(t[r], e[n], !1);
}
function We(o) {
  var e = Et(o, ["paddingLeft", "paddingTop"]), n = e.paddingLeft, t = e.paddingTop;
  return {
    top: parseFloat(t),
    left: parseFloat(n)
  };
}
var Nt = function(o) {
  function e(n, t, r, i, s, a) {
    n === void 0 && (n = 0), t === void 0 && (t = 0), r === void 0 && (r = 0), i === void 0 && (i = 0), s === void 0 && (s = 0), a === void 0 && (a = 0), o.call(this), this.a = n, this.b = t, this.c = r, this.d = i, this.e = s, this.f = a;
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.multiplyCopy = function(t) {
    return new e(
      this.a * t.a + this.c * t.b,
      this.b * t.a + this.d * t.b,
      this.a * t.c + this.c * t.d,
      this.b * t.c + this.d * t.d,
      this.a * t.e + this.c * t.f + this.e,
      this.b * t.e + this.d * t.f + this.f
    );
  }, e.prototype.invert = function() {
    var t = this, r = t.a, i = t.b, s = t.c, a = t.d, h = t.e, p = t.f, c = r * a - i * s;
    return c === 0 ? null : new e(
      a / c,
      -i / c,
      -s / c,
      r / c,
      (s * p - a * h) / c,
      (i * h - r * p) / c
    );
  }, e.prototype.clone = function() {
    return new e(this.a, this.b, this.c, this.d, this.e, this.f);
  }, e.prototype.equals = function(t) {
    return t ? this.a === t.a && this.b === t.b && this.c === t.c && this.d === t.d && this.e === t.e && this.f === t.f : !1;
  }, e.prototype.round = function(t) {
    return this.a = m(this.a, t), this.b = m(this.b, t), this.c = m(this.c, t), this.d = m(this.d, t), this.e = m(this.e, t), this.f = m(this.f, t), this;
  }, e.prototype.toArray = function(t) {
    var r = [this.a, this.b, this.c, this.d, this.e, this.f];
    if (d(t))
      for (var i = 0; i < r.length; i++)
        r[i] = m(r[i], t);
    return r;
  }, e.prototype.toString = function(t, r) {
    return r === void 0 && (r = ","), this.toArray(t).join(r);
  }, e.translate = function(t, r) {
    return new e(1, 0, 0, 1, t, r);
  }, e.unit = function() {
    return new e(1, 0, 0, 1, 0, 0);
  }, e.rotate = function(t, r, i) {
    var s = new e();
    return s.a = Math.cos($(t)), s.b = Math.sin($(t)), s.c = -s.b, s.d = s.a, s.e = r - r * s.a + i * s.b || 0, s.f = i - i * s.a - r * s.b || 0, s;
  }, e.scale = function(t, r) {
    return new e(t, 0, 0, r, 0, 0);
  }, e;
}(S);
Nt.IDENTITY = Nt.unit();
const T = Nt;
var cn = /matrix\((.*)\)/;
function un(o) {
  var e = o.match(cn);
  if (e === null || e.length !== 2)
    return T.unit();
  var n = e[1].split(",").map(function(t) {
    return parseFloat(t);
  });
  return new (Function.prototype.bind.apply(T, [null].concat(n)))();
}
function de(o) {
  var e = getComputedStyle(o).transform;
  return e === "none" ? T.unit() : un(e);
}
function Ze(o) {
  if (!o)
    return T.unit();
  for (var e = de(o), n = o.parentElement; n; ) {
    var t = de(n);
    e = e.multiplyCopy(t), n = n.parentElement;
  }
  return e.b = e.c = e.e = e.f = 0, e;
}
var fn = function(o) {
  function e(n) {
    o.call(this), this._size = n, this._length = 0, this._map = {};
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.put = function(t, r) {
    var i = this._map, s = { key: t, value: r };
    i[t] = s, this._head ? (this._tail.newer = s, s.older = this._tail, this._tail = s) : this._head = this._tail = s, this._length >= this._size ? (i[this._head.key] = null, this._head = this._head.newer, this._head.older = null) : this._length++;
  }, e.prototype.get = function(t) {
    var r = this._map[t];
    if (r)
      return r === this._head && r !== this._tail && (this._head = r.newer, this._head.older = null), r !== this._tail && (r.older && (r.older.newer = r.newer, r.newer.older = r.older), r.older = this._tail, r.newer = null, this._tail.newer = r, this._tail = r), r.value;
  }, e;
}(S);
const Je = fn;
var ln = /\r?\n|\r|\t/g, vn = " ";
function ne(o) {
  return String(o).replace(ln, vn);
}
function Ke(o) {
  var e = [];
  for (var n in o)
    e.push(n + o[n]);
  return e.sort().join("");
}
function Qe(o) {
  for (var e = 2166136261, n = 0; n < o.length; ++n)
    e += (e << 1) + (e << 4) + (e << 7) + (e << 8) + (e << 24), e ^= o.charCodeAt(n);
  return e >>> 0;
}
function me() {
  return { width: 0, height: 0, baseline: 0 };
}
var yn = {
  baselineMarkerSize: 1
}, Vt;
typeof document < "u" && (Vt = document.createElement("div"), Vt.style.cssText = "position: absolute !important; top: -4000px !important; width: auto !important; height: auto !important;padding: 0 !important; margin: 0 !important; border: 0 !important;line-height: normal !important; visibility: hidden !important; white-space: pre!important;");
var Ut = function(o) {
  function e(n) {
    o.call(this), this._cache = new Je(1e3), this.options = Object.assign({}, yn, n);
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.measure = function(t, r, i) {
    if (i === void 0 && (i = {}), typeof t > "u" || t === null)
      return me();
    var s = Ke(r), a = Qe(t + s), h = this._cache.get(a);
    if (h)
      return h;
    var p = me(), c = i.box || Vt, u = this._baselineMarker().cloneNode(!1);
    for (var f in r) {
      var l = r[f];
      typeof l < "u" && (c.style[f] = l);
    }
    var v = i.normalizeText !== !1 ? ne(t) : String(t);
    return c.textContent = v, c.appendChild(u), document.body.appendChild(c), v.length && (p.width = c.offsetWidth - this.options.baselineMarkerSize, p.height = c.offsetHeight, p.baseline = u.offsetTop + this.options.baselineMarkerSize), p.width > 0 && p.height > 0 && this._cache.put(a, p), c.parentNode.removeChild(c), p;
  }, e.prototype._baselineMarker = function() {
    var t = document.createElement("div");
    return t.style.cssText = "display: inline-block; vertical-align: baseline;width: " + this.options.baselineMarkerSize + "px; height: " + this.options.baselineMarkerSize + "px;overflow: hidden;", t;
  }, e;
}(S);
Ut.current = new Ut();
const tr = Ut;
function dn(o, e, n) {
  return tr.current.measure(o, e, n);
}
const rs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DEG_TO_RAD: Qt,
  LRUCache: Je,
  MAX_NUM: Z,
  MIN_NUM: J,
  TextMetrics: tr,
  append: nt,
  arabicToRoman: rn,
  bindEvents: ee,
  createPromise: wt,
  defined: d,
  definitionId: xt,
  deg: F,
  elementOffset: Ye,
  elementPadding: We,
  elementScale: Ze,
  elementSize: et,
  elementStyles: Et,
  encodeBase64: an,
  eventCoordinates: Ve,
  eventElement: Ue,
  hashKey: Qe,
  isTransparent: N,
  last: w,
  limitValue: Ht,
  measureText: dn,
  mergeSort: hn,
  normalizeText: ne,
  now: qt,
  objectKey: Ke,
  promiseAll: Xe,
  rad: $,
  round: m,
  unbindEvents: re,
  valueOrDefault: te
}, Symbol.toStringTag, { value: "Module" }));
var mn = {}.toString, gn = function(o) {
  function e(n, t) {
    var r = this;
    t === void 0 && (t = ""), o.call(this), this.prefix = t;
    for (var i in n) {
      var s = n[i];
      s = r._wrap(s, i), r[i] = s;
    }
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.get = function(t) {
    for (var r = t.split("."), i = this; r.length && i; ) {
      var s = r.shift();
      i = i[s];
    }
    return i;
  }, e.prototype.set = function(t, r) {
    var i = this.get(t);
    i !== r && (this._set(t, this._wrap(r, t)), this.optionsChange({
      field: this.prefix + t,
      value: r
    }));
  }, e.prototype._set = function(t, r) {
    var i = this, s = t.indexOf(".") >= 0, a = this, h = t;
    if (s) {
      for (var p = h.split("."), c = this.prefix; p.length > 1; ) {
        h = p.shift(), c += h + ".";
        var u = a[h];
        u || (u = new e({}, c), u.addObserver(i), a[h] = u), a = u;
      }
      h = p[0];
    }
    a._clear(h), a[h] = r;
  }, e.prototype._clear = function(t) {
    var r = this[t];
    r && r.removeObserver && r.removeObserver(this);
  }, e.prototype._wrap = function(t, r) {
    var i = mn.call(t), s = t;
    return s !== null && d(s) && i === "[object Object]" && (!(t instanceof e) && !(t instanceof S) && (s = new e(s, this.prefix + r + ".")), s.addObserver(this)), s;
  }, e;
}(E);
const er = gn;
function _n(o) {
  return function(e) {
    return this[o] !== e && (this[o] = e, this.geometryChange()), this;
  };
}
function bn(o) {
  return function() {
    return this[o];
  };
}
function wn(o, e) {
  for (var n = 0; n < e.length; n++) {
    var t = e[n], r = t.charAt(0).toUpperCase() + t.substring(1, t.length);
    o["set" + r] = _n(t), o["get" + r] = bn(t);
  }
}
var xn = function(o, e) {
  var n = function(t) {
    function r() {
      t.apply(this, arguments);
    }
    return t && (r.__proto__ = t), r.prototype = Object.create(t && t.prototype), r.prototype.constructor = r, r;
  }(o);
  return wn(n.prototype, e), n;
};
const oe = xn;
function K(o) {
  return o && typeof o.matrix == "function" ? o.matrix() : o;
}
var Cn = function(o) {
  function e(t, r) {
    o.call(this), this.x = t || 0, this.y = r || 0;
  }
  o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e;
  var n = { ZERO: { configurable: !0 } };
  return e.prototype.equals = function(r) {
    return r && r.x === this.x && r.y === this.y;
  }, e.prototype.clone = function() {
    return new e(this.x, this.y);
  }, e.prototype.rotate = function(r, i) {
    var s = e.create(i) || e.ZERO;
    return this.transform(T.rotate(r, s.x, s.y));
  }, e.prototype.translate = function(r, i) {
    return this.x += r, this.y += i, this.geometryChange(), this;
  }, e.prototype.translateWith = function(r) {
    return this.translate(r.x, r.y);
  }, e.prototype.move = function(r, i) {
    return this.x = this.y = 0, this.translate(r, i);
  }, e.prototype.scale = function(r, i) {
    return i === void 0 && (i = r), this.x *= r, this.y *= i, this.geometryChange(), this;
  }, e.prototype.scaleCopy = function(r, i) {
    return this.clone().scale(r, i);
  }, e.prototype.transform = function(r) {
    var i = K(r), s = this, a = s.x, h = s.y;
    return this.x = i.a * a + i.c * h + i.e, this.y = i.b * a + i.d * h + i.f, this.geometryChange(), this;
  }, e.prototype.transformCopy = function(r) {
    var i = this.clone();
    return r && i.transform(r), i;
  }, e.prototype.distanceTo = function(r) {
    var i = this.x - r.x, s = this.y - r.y;
    return Math.sqrt(i * i + s * s);
  }, e.prototype.round = function(r) {
    return this.x = m(this.x, r), this.y = m(this.y, r), this.geometryChange(), this;
  }, e.prototype.toArray = function(r) {
    var i = d(r), s = i ? m(this.x, r) : this.x, a = i ? m(this.y, r) : this.y;
    return [s, a];
  }, e.prototype.toString = function(r, i) {
    i === void 0 && (i = " ");
    var s = this, a = s.x, h = s.y;
    return d(r) && (a = m(a, r), h = m(h, r)), a + i + h;
  }, e.create = function(r, i) {
    if (d(r))
      return r instanceof e ? r : arguments.length === 1 && r.length === 2 ? new e(r[0], r[1]) : new e(r, i);
  }, e.min = function() {
    for (var r = arguments, i = Z, s = Z, a = 0; a < arguments.length; a++) {
      var h = r[a];
      i = Math.min(h.x, i), s = Math.min(h.y, s);
    }
    return new e(i, s);
  }, e.max = function() {
    for (var r = arguments, i = J, s = J, a = 0; a < arguments.length; a++) {
      var h = r[a];
      i = Math.max(h.x, i), s = Math.max(h.y, s);
    }
    return new e(i, s);
  }, e.minPoint = function() {
    return new e(J, J);
  }, e.maxPoint = function() {
    return new e(Z, Z);
  }, n.ZERO.get = function() {
    return new e(0, 0);
  }, Object.defineProperties(e, n), e;
}(oe(E, ["x", "y"]));
const y = Cn;
var Tn = function(o) {
  function e(t, r) {
    o.call(this), this.width = t || 0, this.height = r || 0;
  }
  o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e;
  var n = { ZERO: { configurable: !0 } };
  return e.prototype.equals = function(r) {
    return r && r.width === this.width && r.height === this.height;
  }, e.prototype.clone = function() {
    return new e(this.width, this.height);
  }, e.prototype.toArray = function(r) {
    var i = d(r), s = i ? m(this.width, r) : this.width, a = i ? m(this.height, r) : this.height;
    return [s, a];
  }, e.create = function(r, i) {
    if (d(r))
      return r instanceof e ? r : arguments.length === 1 && r.length === 2 ? new e(r[0], r[1]) : new e(r, i);
  }, n.ZERO.get = function() {
    return new e(0, 0);
  }, Object.defineProperties(e, n), e;
}(oe(E, ["width", "height"]));
const gt = Tn;
var Sn = function(o) {
  function e(n, t, r) {
    n === void 0 && (n = new y()), t === void 0 && (t = new gt()), r === void 0 && (r = 0), o.call(this), this.setOrigin(n), this.setSize(t), this.setCornerRadius(r);
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.clone = function() {
    return new e(
      this.origin.clone(),
      this.size.clone()
    );
  }, e.prototype.equals = function(t) {
    return t && t.origin.equals(this.origin) && t.size.equals(this.size);
  }, e.prototype.setOrigin = function(t) {
    return this._observerField("origin", y.create(t)), this.geometryChange(), this;
  }, e.prototype.getOrigin = function() {
    return this.origin;
  }, e.prototype.setCornerRadius = function(t) {
    return this.cornerRadius = Array.isArray(t) ? t : [t, t], this.geometryChange(), this;
  }, e.prototype.getCornerRadius = function() {
    return this.cornerRadius;
  }, e.prototype.setSize = function(t) {
    return this._observerField("size", gt.create(t)), this.geometryChange(), this;
  }, e.prototype.getSize = function() {
    return this.size;
  }, e.prototype.width = function() {
    return this.size.width;
  }, e.prototype.height = function() {
    return this.size.height;
  }, e.prototype.topLeft = function() {
    return this.origin.clone();
  }, e.prototype.bottomRight = function() {
    return this.origin.clone().translate(this.width(), this.height());
  }, e.prototype.topRight = function() {
    return this.origin.clone().translate(this.width(), 0);
  }, e.prototype.bottomLeft = function() {
    return this.origin.clone().translate(0, this.height());
  }, e.prototype.center = function() {
    return this.origin.clone().translate(this.width() / 2, this.height() / 2);
  }, e.prototype.bbox = function(t) {
    var r = this.topLeft().transformCopy(t), i = this.topRight().transformCopy(t), s = this.bottomRight().transformCopy(t), a = this.bottomLeft().transformCopy(t);
    return e.fromPoints(r, i, s, a);
  }, e.prototype.transformCopy = function(t) {
    return e.fromPoints(
      this.topLeft().transform(t),
      this.bottomRight().transform(t)
    );
  }, e.prototype.expand = function(t, r) {
    return r === void 0 && (r = t), this.size.width += 2 * t, this.size.height += 2 * r, this.origin.translate(-t, -r), this;
  }, e.prototype.expandCopy = function(t, r) {
    return this.clone().expand(t, r);
  }, e.prototype.containsPoint = function(t) {
    var r = this.origin, i = this.bottomRight();
    return !(t.x < r.x || t.y < r.y || i.x < t.x || i.y < t.y);
  }, e.prototype._isOnPath = function(t, r) {
    var i = this.expandCopy(r, r), s = this.expandCopy(-r, -r);
    return i.containsPoint(t) && !s.containsPoint(t);
  }, e.fromPoints = function() {
    var t = y.min.apply(null, arguments), r = y.max.apply(null, arguments), i = new gt(
      r.x - t.x,
      r.y - t.y
    );
    return new e(t, i);
  }, e.union = function(t, r) {
    return e.fromPoints(
      y.min(t.topLeft(), r.topLeft()),
      y.max(t.bottomRight(), r.bottomRight())
    );
  }, e.intersect = function(t, r) {
    var i = {
      left: t.topLeft().x,
      top: t.topLeft().y,
      right: t.bottomRight().x,
      bottom: t.bottomRight().y
    }, s = {
      left: r.topLeft().x,
      top: r.topLeft().y,
      right: r.bottomRight().x,
      bottom: r.bottomRight().y
    };
    if (i.left <= s.right && s.left <= i.right && i.top <= s.bottom && s.top <= i.bottom)
      return e.fromPoints(
        new y(Math.max(i.left, s.left), Math.max(i.top, s.top)),
        new y(Math.min(i.right, s.right), Math.min(i.bottom, s.bottom))
      );
  }, e;
}(E);
const C = Sn;
var An = function(o) {
  function e(n) {
    n === void 0 && (n = T.unit()), o.call(this), this._matrix = n;
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.clone = function() {
    return new e(
      this._matrix.clone()
    );
  }, e.prototype.equals = function(t) {
    return t && t._matrix.equals(this._matrix);
  }, e.prototype.translate = function(t, r) {
    return this._matrix = this._matrix.multiplyCopy(T.translate(t, r)), this._optionsChange(), this;
  }, e.prototype.scale = function(t, r, i) {
    r === void 0 && (r = t), i === void 0 && (i = null);
    var s = i;
    return s && (s = y.create(s), this._matrix = this._matrix.multiplyCopy(T.translate(s.x, s.y))), this._matrix = this._matrix.multiplyCopy(T.scale(t, r)), s && (this._matrix = this._matrix.multiplyCopy(T.translate(-s.x, -s.y))), this._optionsChange(), this;
  }, e.prototype.rotate = function(t, r) {
    var i = y.create(r) || y.ZERO;
    return this._matrix = this._matrix.multiplyCopy(T.rotate(t, i.x, i.y)), this._optionsChange(), this;
  }, e.prototype.multiply = function(t) {
    var r = K(t);
    return this._matrix = this._matrix.multiplyCopy(r), this._optionsChange(), this;
  }, e.prototype.matrix = function(t) {
    return t ? (this._matrix = t, this._optionsChange(), this) : this._matrix;
  }, e.prototype._optionsChange = function() {
    this.optionsChange({
      field: "transform",
      value: this
    });
  }, e;
}(E);
const ge = An;
function P(o) {
  return o === null ? null : o instanceof ge ? o : new ge(o);
}
var On = function(o) {
  function e(t) {
    o.call(this), this._initOptions(t);
  }
  o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e;
  var n = { nodeType: { configurable: !0 } };
  return n.nodeType.get = function() {
    return "Rect";
  }, e.prototype._initOptions = function(r) {
    r === void 0 && (r = {});
    var i = r.clip, s = r.transform;
    s && (r.transform = P(s)), i && !i.id && (i.id = xt()), this.options = new er(r), this.options.addObserver(this);
  }, e.prototype.transform = function(r) {
    if (d(r))
      this.options.set("transform", P(r));
    else
      return this.options.get("transform");
  }, e.prototype.parentTransform = function() {
    for (var r = this, i; r.parent; ) {
      r = r.parent;
      var s = r.transform();
      s && (i = s.matrix().multiplyCopy(i || T.unit()));
    }
    if (i)
      return P(i);
  }, e.prototype.currentTransform = function(r) {
    r === void 0 && (r = this.parentTransform());
    var i = this.transform(), s = K(i), a = K(r), h;
    if (s && a ? h = a.multiplyCopy(s) : h = s || a, h)
      return P(h);
  }, e.prototype.visible = function(r) {
    return d(r) ? (this.options.set("visible", r), this) : this.options.get("visible") !== !1;
  }, e.prototype.clip = function(r) {
    var i = this.options;
    return d(r) ? (r && !r.id && (r.id = xt()), i.set("clip", r), this) : i.get("clip");
  }, e.prototype.opacity = function(r) {
    return d(r) ? (this.options.set("opacity", r), this) : te(this.options.get("opacity"), 1);
  }, e.prototype.clippedBBox = function(r) {
    var i = this._clippedBBox(r);
    if (i) {
      var s = this.clip();
      return s ? C.intersect(i, s.bbox(r)) : i;
    }
  }, e.prototype.containsPoint = function(r, i) {
    if (this.visible()) {
      var s = this.currentTransform(i), a = r;
      return s && (a = r.transformCopy(s.matrix().invert())), this._hasFill() && this._containsPoint(a) || this._isOnPath && this._hasStroke() && this._isOnPath(a);
    }
    return !1;
  }, e.prototype._hasFill = function() {
    var r = this.options.fill;
    return r && !N(r.color);
  }, e.prototype._hasStroke = function() {
    var r = this.options.stroke;
    return r && r.width > 0 && !N(r.color);
  }, e.prototype._clippedBBox = function(r) {
    return this.bbox(r);
  }, Object.defineProperties(e.prototype, n), e;
}(E);
const ot = On;
function Mn(o, e, n, t) {
  var r = 0, i = 0;
  return t && (r = Math.atan2(t.c * n, t.a * e), t.b !== 0 && (i = Math.atan2(t.d * n, t.b * e))), {
    x: r,
    y: i
  };
}
var En = "Gradient", kn = function(o) {
  return function(e) {
    function n() {
      e.apply(this, arguments);
    }
    return e && (n.__proto__ = e), n.prototype = Object.create(e && e.prototype), n.prototype.constructor = n, n.prototype.fill = function(r, i) {
      var s = this.options;
      if (d(r)) {
        if (r && r.nodeType !== En) {
          var a = {
            color: r
          };
          d(i) && (a.opacity = i), s.set("fill", a);
        } else
          s.set("fill", r);
        return this;
      }
      return s.get("fill");
    }, n.prototype.stroke = function(r, i, s) {
      return d(r) ? (this.options.set("stroke.color", r), d(i) && this.options.set("stroke.width", i), d(s) && this.options.set("stroke.opacity", s), this) : this.options.get("stroke");
    }, n;
  }(o);
};
const rr = kn;
var Rn = T.IDENTITY.toString(), $n = function(o) {
  return function(e) {
    function n() {
      e.apply(this, arguments);
    }
    return e && (n.__proto__ = e), n.prototype = Object.create(e && e.prototype), n.prototype.constructor = n, n.prototype.bbox = function(r) {
      var i = K(this.currentTransform(r)), s = i ? i.toString() : Rn, a;
      this._bboxCache && this._matrixHash === s ? a = this._bboxCache.clone() : (a = this._bbox(i), this._bboxCache = a ? a.clone() : null, this._matrixHash = s);
      var h = this.options.get("stroke.width");
      return h && a && a.expand(h / 2), a;
    }, n.prototype.geometryChange = function() {
      delete this._bboxCache, this.trigger("geometryChange", {
        element: this
      });
    }, n;
  }(o);
};
const nr = $n;
function Pn(o) {
  var e = "_" + o;
  return function(n) {
    return d(n) ? (this._observerField(e, n), this.geometryChange(), this) : this[e];
  };
}
function In(o, e) {
  for (var n = 0; n < e.length; n++)
    o[e[n]] = Pn(e[n]);
}
var Ln = function(o, e) {
  e === void 0 && (e = ["geometry"]);
  var n = function(t) {
    function r() {
      t.apply(this, arguments);
    }
    return t && (r.__proto__ = t), r.prototype = Object.create(t && t.prototype), r.prototype.constructor = r, r;
  }(o);
  return In(n.prototype, e), n;
};
const Dn = Ln;
var I = 10;
function or(o, e, n) {
  return n === void 0 && (n = I), m(Math.abs(o - e), n) === 0;
}
function It(o, e, n) {
  return o < e || or(o, e, n);
}
function jn(o, e, n, t) {
  var r = e.x - o.x, i = t.x - n.x, s = e.y - o.y, a = t.y - n.y, h = o.x - n.x, p = o.y - n.y, c = r * a - i * s, u = (r * p - s * h) / c, f = (i * p - a * h) / c;
  if (u >= 0 && u <= 1 && f >= 0 && f <= 1)
    return new y(o.x + f * r, o.y + f * s);
}
var zn = 45, yt = Math.pow, Fn = ["radiusX", "radiusY", "startAngle", "endAngle", "anticlockwise"], Gn = function(o) {
  function e(n, t) {
    n === void 0 && (n = new y()), t === void 0 && (t = {}), o.call(this), this.setCenter(n), this.radiusX = t.radiusX, this.radiusY = t.radiusY || t.radiusX, this.startAngle = t.startAngle, this.endAngle = t.endAngle, this.anticlockwise = t.anticlockwise || !1, this.xRotation = t.xRotation;
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.clone = function() {
    return new e(this.center, {
      radiusX: this.radiusX,
      radiusY: this.radiusY,
      startAngle: this.startAngle,
      endAngle: this.endAngle,
      anticlockwise: this.anticlockwise
    });
  }, e.prototype.setCenter = function(t) {
    return this._observerField("center", y.create(t)), this.geometryChange(), this;
  }, e.prototype.getCenter = function() {
    return this.center;
  }, e.prototype.pointAt = function(t) {
    var r = this.center, i = $(t);
    return new y(
      r.x + this.radiusX * Math.cos(i),
      r.y + this.radiusY * Math.sin(i)
    );
  }, e.prototype.curvePoints = function() {
    var t = this, r = this.startAngle, i = this.anticlockwise ? -1 : 1, s = [this.pointAt(r)], a = this._arcInterval(), h = a.endAngle - a.startAngle, p = Math.ceil(h / zn), c = h / p, u = r, f;
    this.xRotation && (f = P().rotate(this.xRotation, this.center));
    for (var l = 1; l <= p; l++) {
      var v = u + i * c, g = t._intervalCurvePoints(u, v, f);
      s.push(g.cp1, g.cp2, g.p2), u = v;
    }
    return s;
  }, e.prototype.bbox = function(t) {
    for (var r = this, i = this._arcInterval(), s = i.startAngle, a = i.endAngle, h = Mn(this.center, this.radiusX, this.radiusY, t), p = F(h.x), c = F(h.y), u = this.pointAt(a).transformCopy(t), f = be(p, s), l = be(c, s), v = this.pointAt(s).transformCopy(t), g = y.min(v, u), _ = y.max(v, u); f < a || l < a; ) {
      var b = void 0;
      f < a && (b = r.pointAt(f).transformCopy(t), f += 90);
      var x = void 0;
      l < a && (x = r.pointAt(l).transformCopy(t), l += 90), v = new y(b.x, x.y), g = y.min(g, v), _ = y.max(_, v);
    }
    return C.fromPoints(g, _);
  }, e.prototype._arcInterval = function() {
    var t = this, r = t.startAngle, i = t.endAngle, s = t.anticlockwise;
    if (s) {
      var a = r;
      r = i, i = a;
    }
    return (r > i || s && r === i) && (i += 360), {
      startAngle: r,
      endAngle: i
    };
  }, e.prototype._intervalCurvePoints = function(t, r, i) {
    var s = this.pointAt(t), a = this.pointAt(r), h = this._derivativeAt(t), p = this._derivativeAt(r), c = ($(r) - $(t)) / 3, u = new y(s.x + c * h.x, s.y + c * h.y), f = new y(a.x - c * p.x, a.y - c * p.y);
    return i && (s.transform(i), a.transform(i), u.transform(i), f.transform(i)), {
      p1: s,
      cp1: u,
      cp2: f,
      p2: a
    };
  }, e.prototype._derivativeAt = function(t) {
    var r = $(t);
    return new y(-this.radiusX * Math.sin(r), this.radiusY * Math.cos(r));
  }, e.prototype.containsPoint = function(t) {
    var r = this._arcInterval(), i = r.endAngle - r.startAngle, s = this, a = s.center, h = s.radiusX, p = s.radiusY, c = a.distanceTo(t), u = Math.atan2(t.y - a.y, t.x - a.x), f = h * p / Math.sqrt(yt(h, 2) * yt(Math.sin(u), 2) + yt(p, 2) * yt(Math.cos(u), 2)), l = this.pointAt(this.startAngle).round(I), v = this.pointAt(this.endAngle).round(I), g = jn(a, t.round(I), l, v), _;
    if (i < 180)
      _ = g && It(a.distanceTo(g), c) && It(c, f);
    else {
      var b = _e(a.x, a.y, h, p, t.x, t.y);
      b !== 360 && (b = (360 + b) % 360);
      var x = r.startAngle <= b && b <= r.endAngle;
      _ = x && It(c, f) || !x && (!g || g.equals(t));
    }
    return _;
  }, e.prototype._isOnPath = function(t, r) {
    var i = this._arcInterval(), s = this.center, a = _e(s.x, s.y, this.radiusX, this.radiusY, t.x, t.y);
    a !== 360 && (a = (360 + a) % 360);
    var h = i.startAngle <= a && a <= i.endAngle;
    return h && this.pointAt(a).distanceTo(t) <= r;
  }, e.fromPoints = function(t, r, i, s, a, h, p) {
    var c = qn({
      x1: t.x,
      y1: t.y,
      x2: r.x,
      y2: r.y,
      rx: i,
      ry: s,
      largeArc: a,
      swipe: h,
      rotation: p
    });
    return new e(c.center, {
      startAngle: c.startAngle,
      endAngle: c.endAngle,
      radiusX: c.radiusX,
      radiusY: c.radiusY,
      xRotation: c.xRotation,
      anticlockwise: h === 0
    });
  }, e;
}(oe(E, Fn));
function _e(o, e, n, t, r, i) {
  var s = m((r - o) / n, 3), a = m((i - e) / t, 3);
  return m(F(Math.atan2(a, s)));
}
function qn(o) {
  var e = o.x1, n = o.y1, t = o.x2, r = o.y2, i = o.rx, s = o.ry, a = o.largeArc, h = o.swipe, p = o.rotation;
  p === void 0 && (p = 0);
  var c = $(p), u = Math.cos(c), f = Math.sin(c), l = u * (e - t) / 2 + f * (n - r) / 2, v = -f * (e - t) / 2 + u * (n - r) / 2, g = a !== h ? 1 : -1, _ = Math.pow(l, 2), b = Math.pow(v, 2), x = Math.pow(i, 2), W = Math.pow(s, 2), it = _ / x + b / W;
  it > 1 && (it = Math.sqrt(_ / x + b / W), i = it * i, x = Math.pow(i, 2), s = it * s, W = Math.pow(s, 2));
  var st = g * Math.sqrt((x * W - x * b - W * _) / (x * b + W * _));
  isNaN(st) && (st = 0);
  var at = st * (i * v) / s, ht = -st * (s * l) / i, $r = u * at - f * ht + (e + t) / 2, Pr = f * at + u * ht + (n + r) / 2, G = (l - at) / i, q = (v - ht) / s, pt = -(l + at) / i, ct = -(v + ht) / s, ce = (q >= 0 ? 1 : -1) * F(Math.acos(G / Math.sqrt(G * G + q * q))), Ir = m((G * pt + q * ct) / (Math.sqrt(G * G + q * q) * Math.sqrt(pt * pt + ct * ct)), 10), Q = (G * ct - q * pt >= 0 ? 1 : -1) * F(Math.acos(Ir));
  !h && Q > 0 && (Q -= 360), h && Q < 0 && (Q += 360);
  var ut = ce + Q, Lr = ut >= 0 ? 1 : -1;
  return ut = Math.abs(ut) % 360 * Lr, {
    center: new y($r, Pr),
    startAngle: ce,
    endAngle: ut,
    radiusX: i,
    radiusY: s,
    xRotation: p
  };
}
function be(o, e) {
  for (var n = o; n < e; )
    n += 90;
  return n;
}
const we = Gn;
var Bn = [].push, Hn = [].pop, Nn = [].splice, Vn = [].shift, xe = [].slice, Un = [].unshift, Xn = function(o) {
  function e(n) {
    n === void 0 && (n = []), o.call(this), this.length = 0, this._splice(0, n.length, n);
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.elements = function(t) {
    return t ? (this._splice(0, this.length, t), this._change(), this) : this.slice(0);
  }, e.prototype.push = function() {
    var t = arguments, r = Bn.apply(this, t);
    return this._add(t), r;
  }, e.prototype.slice = function() {
    return xe.call(this);
  }, e.prototype.pop = function() {
    var t = this.length, r = Hn.apply(this);
    return t && this._remove([r]), r;
  }, e.prototype.splice = function(t, r) {
    var i = xe.call(arguments, 2), s = this._splice(t, r, i);
    return this._change(), s;
  }, e.prototype.shift = function() {
    var t = this.length, r = Vn.apply(this);
    return t && this._remove([r]), r;
  }, e.prototype.unshift = function() {
    var t = arguments, r = Un.apply(this, t);
    return this._add(t), r;
  }, e.prototype.indexOf = function(t) {
    for (var r = this, i = this.length, s = 0; s < i; s++)
      if (r[s] === t)
        return s;
    return -1;
  }, e.prototype._splice = function(t, r, i) {
    var s = Nn.apply(this, [t, r].concat(i));
    return this._clearObserver(s), this._setObserver(i), s;
  }, e.prototype._add = function(t) {
    this._setObserver(t), this._change();
  }, e.prototype._remove = function(t) {
    this._clearObserver(t), this._change();
  }, e.prototype._setObserver = function(t) {
    for (var r = this, i = 0; i < t.length; i++)
      t[i].addObserver(r);
  }, e.prototype._clearObserver = function(t) {
    for (var r = this, i = 0; i < t.length; i++)
      t[i].removeObserver(r);
  }, e.prototype._change = function() {
  }, e;
}(E);
const ir = Xn;
var Yn = function(o) {
  function e() {
    o.apply(this, arguments);
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype._change = function() {
    this.geometryChange();
  }, e;
}(ir);
const sr = Yn;
function Ce(o, e, n) {
  var t = F(Math.atan2(e.y - o.y, e.x - o.x)), r = n.transformCopy(P().rotate(-t, o));
  return r.x < o.x;
}
function Ct(o, e, n) {
  var t = 1 - o;
  return Math.pow(t, 3) * n[0][e] + 3 * Math.pow(t, 2) * o * n[1][e] + 3 * Math.pow(o, 2) * t * n[2][e] + Math.pow(o, 3) * n[3][e];
}
function ar(o, e) {
  return [
    -o[0][e] + 3 * o[1][e] - 3 * o[2][e] + o[3][e],
    3 * (o[0][e] - 2 * o[1][e] + o[2][e]),
    3 * (-o[0][e] + o[1][e]),
    o[0][e]
  ];
}
var Wn = function(o) {
  function e(n, t) {
    n === void 0 && (n = 0), t === void 0 && (t = 0), o.call(this), this.real = n, this.img = t;
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.add = function(t) {
    return new e(m(this.real + t.real, I), m(this.img + t.img, I));
  }, e.prototype.addConstant = function(t) {
    return new e(this.real + t, this.img);
  }, e.prototype.negate = function() {
    return new e(-this.real, -this.img);
  }, e.prototype.multiply = function(t) {
    return new e(
      this.real * t.real - this.img * t.img,
      this.real * t.img + this.img * t.real
    );
  }, e.prototype.multiplyConstant = function(t) {
    return new e(this.real * t, this.img * t);
  }, e.prototype.nthRoot = function(t) {
    var r = Math.atan2(this.img, this.real), i = Math.sqrt(Math.pow(this.img, 2) + Math.pow(this.real, 2)), s = Math.pow(i, 1 / t);
    return new e(s * Math.cos(r / t), s * Math.sin(r / t));
  }, e.prototype.equals = function(t) {
    return this.real === t.real && this.img === t.img;
  }, e.prototype.isReal = function() {
    return this.img === 0;
  }, e;
}(S);
const tt = Wn;
function Te(o) {
  return o < 0 ? -1 : 1;
}
function Zn(o, e, n) {
  var t = Math.sqrt(Math.pow(e, 2) - 4 * o * n);
  return [
    (-e + t) / (2 * o),
    (-e - t) / (2 * o)
  ];
}
function hr(o, e, n, t) {
  if (o === 0)
    return Zn(e, n, t);
  var r = (3 * o * n - Math.pow(e, 2)) / (3 * Math.pow(o, 2)), i = (2 * Math.pow(e, 3) - 9 * o * e * n + 27 * Math.pow(o, 2) * t) / (27 * Math.pow(o, 3)), s = Math.pow(r / 3, 3) + Math.pow(i / 2, 2), a = new tt(0, 1), h = -e / (3 * o), p, c, u, f, l, v, g;
  s < 0 ? (p = new tt(-i / 2, Math.sqrt(-s)).nthRoot(3), c = new tt(-i / 2, -Math.sqrt(-s)).nthRoot(3)) : (p = -i / 2 + Math.sqrt(s), p = new tt(Te(p) * Math.pow(Math.abs(p), 1 / 3)), c = -i / 2 - Math.sqrt(s), c = new tt(Te(c) * Math.pow(Math.abs(c), 1 / 3))), u = p.add(c), v = p.add(c).multiplyConstant(-1 / 2), g = p.add(c.negate()).multiplyConstant(Math.sqrt(3) / 2), f = v.add(a.multiply(g)), l = v.add(a.negate().multiply(g));
  var _ = [];
  return u.isReal() && _.push(m(u.real + h, I)), f.isReal() && _.push(m(f.real + h, I)), l.isReal() && _.push(m(l.real + h, I)), _;
}
function dt(o, e, n, t, r) {
  for (var i = ar(o, t), s = hr(i[0], i[1], i[2], i[3] - e[t]), a, h = 0; h < s.length; h++)
    if (0 <= s[h] && s[h] <= 1 && (a = Ct(s[h], n, o), Math.abs(a - e[n]) <= r))
      return !0;
}
function Jn(o, e, n) {
  for (var t = ar(o, "x"), r = hr(t[0], t[1], t[2], t[3] - e.x), i, s, a = 0, h = 0; h < r.length; h++)
    i = Ct(r[h], "y", o), s = or(i, e.y) || i > e.y, s && ((r[h] === 0 || r[h] === 1) && n.bottomRight().x > e.x || 0 < r[h] && r[h] < 1) && a++;
  return a;
}
function pr(o, e, n) {
  var t;
  if (o.x !== e.x) {
    var r = Math.min(o.x, e.x), i = Math.max(o.x, e.x), s = Math.min(o.y, e.y), a = Math.max(o.y, e.y), h = r <= n.x && n.x < i;
    s === a ? t = n.y <= s && h : t = h && (a - s) * ((o.x - e.x) * (o.y - e.y) > 0 ? n.x - r : i - n.x) / (i - r) + s - n.y >= 0;
  }
  return t ? 1 : 0;
}
function Kn(o) {
  var e = "_" + o;
  return function(n) {
    return d(n) ? (this._observerField(e, y.create(n)), this.geometryChange(), this) : this[e];
  };
}
function Qn(o, e) {
  for (var n = 0; n < e.length; n++)
    o[e[n]] = Kn(e[n]);
}
var to = function(o, e) {
  var n = function(t) {
    function r() {
      t.apply(this, arguments);
    }
    return t && (r.__proto__ = t), r.prototype = Object.create(t && t.prototype), r.prototype.constructor = r, r;
  }(o);
  return Qn(n.prototype, e), n;
};
const ie = to;
var eo = ["anchor", "controlIn", "controlOut"], ro = function(o) {
  function e(n, t, r) {
    o.call(this), this.anchor(n || new y()), this.controlIn(t), this.controlOut(r);
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.bboxTo = function(t, r) {
    var i = this.anchor().transformCopy(r), s = t.anchor().transformCopy(r), a;
    return this.controlOut() && t.controlIn() ? a = this._curveBoundingBox(
      i,
      this.controlOut().transformCopy(r),
      t.controlIn().transformCopy(r),
      s
    ) : a = this._lineBoundingBox(i, s), a;
  }, e.prototype._lineBoundingBox = function(t, r) {
    return C.fromPoints(t, r);
  }, e.prototype._curveBoundingBox = function(t, r, i, s) {
    var a = [t, r, i, s], h = this._curveExtremesFor(a, "x"), p = this._curveExtremesFor(a, "y"), c = Se([h.min, h.max, t.x, s.x]), u = Se([p.min, p.max, t.y, s.y]);
    return C.fromPoints(new y(c.min, u.min), new y(c.max, u.max));
  }, e.prototype._curveExtremesFor = function(t, r) {
    var i = this._curveExtremes(
      t[0][r],
      t[1][r],
      t[2][r],
      t[3][r]
    );
    return {
      min: Ct(i.min, r, t),
      max: Ct(i.max, r, t)
    };
  }, e.prototype._curveExtremes = function(t, r, i, s) {
    var a = t - 3 * r + 3 * i - s, h = -2 * (t - 2 * r + i), p = t - r, c = Math.sqrt(h * h - 4 * a * p), u = 0, f = 1;
    a === 0 ? h !== 0 && (u = f = -p / h) : isNaN(c) || (u = (-h + c) / (2 * a), f = (-h - c) / (2 * a));
    var l = Math.max(Math.min(u, f), 0);
    (l < 0 || l > 1) && (l = 0);
    var v = Math.min(Math.max(u, f), 1);
    return (v > 1 || v < 0) && (v = 1), {
      min: l,
      max: v
    };
  }, e.prototype._intersectionsTo = function(t, r) {
    var i;
    return this.controlOut() && t.controlIn() ? i = Jn([this.anchor(), this.controlOut(), t.controlIn(), t.anchor()], r, this.bboxTo(t)) : i = pr(this.anchor(), t.anchor(), r), i;
  }, e.prototype._isOnCurveTo = function(t, r, i, s) {
    var a = this.bboxTo(t).expand(i, i);
    if (a.containsPoint(r)) {
      var h = this.anchor(), p = this.controlOut(), c = t.controlIn(), u = t.anchor();
      if (s === "start" && h.distanceTo(r) <= i)
        return !Ce(h, p, r);
      if (s === "end" && u.distanceTo(r) <= i)
        return !Ce(u, c, r);
      var f = [h, p, c, u];
      if (dt(f, r, "x", "y", i) || dt(f, r, "y", "x", i))
        return !0;
      var l = P().rotate(45, r), v = [h.transformCopy(l), p.transformCopy(l), c.transformCopy(l), u.transformCopy(l)];
      return dt(v, r, "x", "y", i) || dt(v, r, "y", "x", i);
    }
  }, e.prototype._isOnLineTo = function(t, r, i) {
    var s = this.anchor(), a = t.anchor(), h = F(Math.atan2(a.y - s.y, a.x - s.x)), p = new C([s.x, s.y - i / 2], [s.distanceTo(a), i]);
    return p.containsPoint(r.transformCopy(P().rotate(-h, s)));
  }, e.prototype._isOnPathTo = function(t, r, i, s) {
    var a;
    return this.controlOut() && t.controlIn() ? a = this._isOnCurveTo(t, r, i / 2, s) : a = this._isOnLineTo(t, r, i), a;
  }, e;
}(ie(E, eo));
function Se(o) {
  for (var e = o.length, n = Z, t = J, r = 0; r < e; r++)
    t = Math.max(t, o[r]), n = Math.min(n, o[r]);
  return {
    min: n,
    max: t
  };
}
const z = ro;
var cr = 0.333, no = 0.01, O = "x", M = "y";
function oo(o, e) {
  var n = o.slice(0), t = [], r = n.length;
  if (r > 2 && (Ae(0, n), r = n.length), r < 2 || r === 2 && n[0].equals(n[1]))
    return t;
  var i = n[0], s = n[1], a = n[2];
  for (t.push(new z(i)); i.equals(n[r - 1]); )
    e = !0, n.pop(), r--;
  if (r === 2) {
    var h = rt(i, s, O, M);
    return w(t).controlOut(
      Xt(h, i, s, O, M)
    ), t.push(new z(
      s,
      Yt(h, i, s, O, M)
    )), t;
  }
  var p, c;
  if (e) {
    i = n[r - 1], s = n[0], a = n[1];
    var u = Lt(i, s, a);
    p = u[1], c = u[0];
  } else {
    var f = rt(i, s, O, M);
    p = Xt(f, i, s, O, M);
  }
  for (var l = p, v = 0; v <= r - 3; v++)
    if (Ae(v, n), r = n.length, v + 3 <= r) {
      i = n[v], s = n[v + 1], a = n[v + 2];
      var g = Lt(i, s, a);
      w(t).controlOut(l), l = g[1];
      var _ = g[0];
      t.push(new z(s, _));
    }
  if (e) {
    i = n[r - 2], s = n[r - 1], a = n[0];
    var b = Lt(i, s, a);
    w(t).controlOut(l), t.push(new z(
      s,
      b[0]
    )), w(t).controlOut(b[1]), t.push(new z(
      a,
      c
    ));
  } else {
    var x = rt(s, a, O, M);
    w(t).controlOut(l), t.push(new z(
      a,
      Yt(x, s, a, O, M)
    ));
  }
  return t;
}
function Ae(o, e) {
  for (; e[o + 1] && (e[o].equals(e[o + 1]) || e[o + 1].equals(e[o + 2])); )
    e.splice(o + 1, 1);
}
function io(o, e, n) {
  var t = !1;
  if (o.x === e.x)
    t = !0;
  else if (e.x === n.x)
    (e.y < n.y && o.y <= e.y || n.y < e.y && e.y <= o.y) && (t = !0);
  else {
    var r = ur(o, e), i = lr(r, n.x);
    !(o.y <= e.y && n.y <= i) && !(e.y <= o.y && n.y >= i) && (t = !0);
  }
  return t;
}
function so(o, e, n) {
  var t = ur(o, e), r = lr(t, n.x);
  return o.x === e.x && e.x === n.x || m(r, 1) === m(n.y, 1);
}
function ur(o, e) {
  var n = (e.y - o.y) / (e.x - o.x), t = o.y - n * o.x;
  return [t, n];
}
function Lt(o, e, n) {
  var t = O, r = M, i = !1, s = !1, a;
  if (so(o, e, n))
    a = rt(o, e, O, M);
  else {
    var h = {
      x: Me(o, e, n, O),
      y: Me(o, e, n, M)
    };
    if (h.x && h.y)
      a = rt(o, n, O, M), i = !0;
    else if (io(o, e, n) && (t = M, r = O), h[t])
      a = 0;
    else {
      var p;
      n[r] < o[r] && o[r] <= e[r] || o[r] < n[r] && e[r] <= o[r] ? p = Ee((n[r] - o[r]) * (e[t] - o[t])) : p = -Ee((n[t] - o[t]) * (e[r] - o[r])), a = no * p, s = !0;
    }
  }
  var c = Yt(a, o, e, t, r);
  if (s) {
    var u = t;
    t = r, r = u;
  }
  var f = Xt(a, e, n, t, r);
  return i && (Oe(o, e, c, a), Oe(e, n, f, a)), [c, f];
}
function Oe(o, e, n, t) {
  o.y < e.y ? e.y < n.y ? (n.x = o.x + (e.y - o.y) / t, n.y = e.y) : n.y < o.y && (n.x = e.x - (e.y - o.y) / t, n.y = o.y) : n.y < e.y ? (n.x = o.x - (o.y - e.y) / t, n.y = e.y) : o.y < n.y && (n.x = e.x + (o.y - e.y) / t, n.y = o.y);
}
function rt(o, e, n, t) {
  var r = e[n] - o[n], i = e[t] - o[t], s;
  return r === 0 ? s = 0 : s = i / r, s;
}
function Me(o, e, n, t) {
  return n[t] > e[t] && e[t] > o[t] || n[t] < e[t] && e[t] < o[t];
}
function Xt(o, e, n, t, r) {
  var i = e[t], s = n[t], a = (s - i) * cr;
  return fr(i + a, e[r] + a * o, t, r);
}
function Yt(o, e, n, t, r) {
  var i = e[t], s = n[t], a = (s - i) * cr;
  return fr(s - a, n[r] - a * o, t, r);
}
function fr(o, e, n, t) {
  var r = new y();
  return r[n] = o, r[t] = e, r;
}
function lr(o, e) {
  for (var n = o.length, t = 0, r = 0; r < n; r++)
    t += Math.pow(e, r) * o[r];
  return t;
}
function Ee(o) {
  return o <= 0 ? -1 : 1;
}
var ao = {
  l: function(o, e) {
    for (var n = e.parameters, t = e.position, r = 0; r < n.length; r += 2) {
      var i = new y(n[r], n[r + 1]);
      e.isRelative && i.translateWith(t), o.lineTo(i.x, i.y), t.x = i.x, t.y = i.y;
    }
  },
  c: function(o, e) {
    for (var n = e.parameters, t = e.position, r = 0; r < n.length; r += 6) {
      var i = new y(n[r], n[r + 1]), s = new y(n[r + 2], n[r + 3]), a = new y(n[r + 4], n[r + 5]);
      e.isRelative && (s.translateWith(t), i.translateWith(t), a.translateWith(t)), o.curveTo(i, s, a), t.x = a.x, t.y = a.y;
    }
  },
  v: function(o, e) {
    var n = e.isRelative ? 0 : e.position.x;
    ke(e.parameters, !0, n), this.l(o, e);
  },
  h: function(o, e) {
    var n = e.isRelative ? 0 : e.position.y;
    ke(e.parameters, !1, n), this.l(o, e);
  },
  a: function(o, e) {
    for (var n = e.parameters, t = e.position, r = 0; r < n.length; r += 7) {
      var i = n[r], s = n[r + 1], a = n[r + 2], h = n[r + 3], p = n[r + 4], c = new y(n[r + 5], n[r + 6]);
      e.isRelative && c.translateWith(t), (t.x !== c.x || t.y !== c.y) && (o.arcTo(c, i, s, h, p, a), t.x = c.x, t.y = c.y);
    }
  },
  s: function(o, e) {
    var n = e.parameters, t = e.position, r = e.previousCommand, i;
    (r === "s" || r === "c") && (i = w(w(o.paths).segments).controlIn());
    for (var s = 0; s < n.length; s += 4) {
      var a = new y(n[s], n[s + 1]), h = new y(n[s + 2], n[s + 3]), p = void 0;
      e.isRelative && (a.translateWith(t), h.translateWith(t)), i ? p = Re(i, t) : p = t.clone(), i = a, o.curveTo(p, a, h), t.x = h.x, t.y = h.y;
    }
  },
  q: function(o, e) {
    for (var n = e.parameters, t = e.position, r = 0; r < n.length; r += 4) {
      var i = new y(n[r], n[r + 1]), s = new y(n[r + 2], n[r + 3]);
      e.isRelative && (i.translateWith(t), s.translateWith(t));
      var a = Pe(t, i, s);
      o.curveTo(a.controlOut, a.controlIn, s), t.x = s.x, t.y = s.y;
    }
  },
  t: function(o, e) {
    var n = e.parameters, t = e.position, r = e.previousCommand, i;
    if (r === "q" || r === "t") {
      var s = w(w(o.paths).segments);
      i = s.controlIn().clone().translateWith(t.scaleCopy(-1 / 3)).scale(3 / 2);
    }
    for (var a = 0; a < n.length; a += 2) {
      var h = new y(n[a], n[a + 1]);
      e.isRelative && h.translateWith(t), i ? i = Re(i, t) : i = t.clone();
      var p = Pe(t, i, h);
      o.curveTo(p.controlOut, p.controlIn, h), t.x = h.x, t.y = h.y;
    }
  }
};
function ke(o, e, n) {
  for (var t = e ? 0 : 1, r = 0; r < o.length; r += 2)
    o.splice(r + t, 0, n);
}
function Re(o, e) {
  if (o && e)
    return e.scaleCopy(2).translate(-o.x, -o.y);
}
var $e = 1 / 3;
function Pe(o, e, n) {
  var t = e.clone().scale(0.6666666666666666);
  return {
    controlOut: t.clone().translateWith(o.scaleCopy($e)),
    controlIn: t.translateWith(n.scaleCopy($e))
  };
}
const Ie = ao;
var ho = /([a-df-z]{1})([^a-df-z]*)(z)?/gi, po = /[,\s]?([+\-]?(?:\d*\.\d+|\d+)(?:[eE][+\-]?\d+)?)/g, Le = "m", co = "z";
function uo(o) {
  var e = [];
  return o.replace(po, function(n, t) {
    e.push(parseFloat(t));
  }), e;
}
function fo(o, e) {
  var n = new y(), t;
  return e.replace(ho, function(r, i, s, a) {
    var h = i.toLowerCase(), p = h === i, c = uo(s.trim());
    if (h === Le && (p ? (n.x += c[0], n.y += c[1]) : (n.x = c[0], n.y = c[1]), o.moveTo(n.x, n.y), c.length > 2 && (h = "l", c.splice(0, 2))), Ie[h])
      Ie[h](
        o,
        {
          parameters: c,
          position: n,
          isRelative: p,
          previousCommand: t
        }
      ), a && a.toLowerCase() === co && o.close();
    else if (h !== Le)
      throw new Error("Error while parsing SVG path. Unsupported command: " + h);
    t = h;
  }), o;
}
function Tt(o, e, n) {
  for (var t, r = 0; r < o.length; r++) {
    var i = o[r];
    if (i.visible()) {
      var s = e ? i.bbox(n) : i.rawBBox();
      s && (t ? t = C.union(t, s) : t = s);
    }
  }
  return t;
}
function vr(o, e) {
  for (var n, t = 0; t < o.length; t++) {
    var r = o[t];
    if (r.visible()) {
      var i = r.clippedBBox(e);
      i && (n ? n = C.union(n, i) : n = i);
    }
  }
  return n;
}
var St = " ", lo = function(o) {
  return function() {
    for (var e = [], n = arguments.length; n--; )
      e[n] = arguments[n];
    return e.map(function(t) {
      return t.toString(o);
    }).join(St);
  };
}, vo = function(o, e) {
  return o.controlOut() && e.controlIn() ? "C" : "L";
}, yr = function(o) {
  function e(t) {
    o.call(this, t), this.segments = new sr(), this.segments.addObserver(this), d(this.options.stroke) || (this.stroke("#000"), d(this.options.stroke.lineJoin) || this.options.set("stroke.lineJoin", "miter"));
  }
  o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e;
  var n = { nodeType: { configurable: !0 } };
  return n.nodeType.get = function() {
    return "Path";
  }, e.prototype.moveTo = function(r, i) {
    return this.suspend(), this.segments.elements([]), this.resume(), this.lineTo(r, i), this;
  }, e.prototype.lineTo = function(r, i) {
    var s = d(i) ? new y(r, i) : r, a = new z(s);
    return this.segments.push(a), this;
  }, e.prototype.curveTo = function(r, i, s) {
    if (this.segments.length > 0) {
      var a = w(this.segments), h = new z(s, i);
      this.suspend(), a.controlOut(r), this.resume(), this.segments.push(h);
    }
    return this;
  }, e.prototype.arc = function(r, i, s, a, h) {
    if (this.segments.length > 0) {
      var p = w(this.segments), c = p.anchor(), u = $(r), f = new y(
        c.x - s * Math.cos(u),
        c.y - a * Math.sin(u)
      ), l = new we(f, {
        startAngle: r,
        endAngle: i,
        radiusX: s,
        radiusY: a,
        anticlockwise: h
      });
      this._addArcSegments(l);
    }
    return this;
  }, e.prototype.arcTo = function(r, i, s, a, h, p) {
    if (this.segments.length > 0) {
      var c = w(this.segments), u = c.anchor(), f = we.fromPoints(u, y.create(r), i, s, a, h, p);
      this._addArcSegments(f);
    }
    return this;
  }, e.prototype._addArcSegments = function(r) {
    var i = this;
    this.suspend();
    for (var s = r.curvePoints(), a = 1; a < s.length; a += 3)
      i.curveTo(s[a], s[a + 1], s[a + 2]);
    this.resume(), this.geometryChange();
  }, e.prototype.close = function() {
    return this.options.closed = !0, this.geometryChange(), this;
  }, e.prototype.rawBBox = function() {
    return this._bbox();
  }, e.prototype.toString = function(r) {
    var i = "", s = this.segments, a = s.length;
    if (a > 0) {
      for (var h = [], p = lo(r), c, u = 1; u < a; u++) {
        var f = vo(s[u - 1], s[u]);
        f !== c && (c = f, h.push(f)), f === "L" ? h.push(p(s[u].anchor())) : h.push(p(
          s[u - 1].controlOut(),
          s[u].controlIn(),
          s[u].anchor()
        ));
      }
      i = "M" + p(s[0].anchor()) + St + h.join(St), this.options.closed && (i += "Z");
    }
    return i;
  }, e.prototype._containsPoint = function(r) {
    for (var i = this.segments, s = i.length, a = 0, h, p, c = 1; c < s; c++)
      h = i[c - 1], p = i[c], a += h._intersectionsTo(p, r);
    return (this.options.closed || !i[0].anchor().equals(i[s - 1].anchor())) && (a += pr(i[0].anchor(), i[s - 1].anchor(), r)), a % 2 !== 0;
  }, e.prototype._isOnPath = function(r, i) {
    var s = this.segments, a = s.length, h = i || this.options.stroke.width;
    if (a > 1) {
      if (s[0]._isOnPathTo(s[1], r, h, "start"))
        return !0;
      for (var p = 2; p <= a - 2; p++)
        if (s[p - 1]._isOnPathTo(s[p], r, h))
          return !0;
      if (s[a - 2]._isOnPathTo(s[a - 1], r, h, "end"))
        return !0;
    }
    return !1;
  }, e.prototype._bbox = function(r) {
    var i = this.segments, s = i.length, a;
    if (s === 1) {
      var h = i[0].anchor().transformCopy(r);
      a = new C(h, gt.ZERO);
    } else if (s > 0)
      for (var p = 1; p < s; p++) {
        var c = i[p - 1].bboxTo(i[p], r);
        a ? a = C.union(a, c) : a = c;
      }
    return a;
  }, e.parse = function(r, i) {
    return yo.parse(r, i);
  }, e.fromRect = function(r, i) {
    var s = new e(i), a = r.cornerRadius, h = a[0], p = a[1];
    if (h === 0 && p === 0)
      s.moveTo(r.topLeft()).lineTo(r.topRight()).lineTo(r.bottomRight()).lineTo(r.bottomLeft()).close();
    else {
      var c = r.origin, u = c.x, f = c.y, l = r.width(), v = r.height();
      h = Ht(h, 0, l / 2), p = Ht(p, 0, v / 2), s.moveTo(u + h, f).lineTo(u + l - h, f).arcTo([u + l, f + p], h, p, !1).lineTo(u + l, f + v - p).arcTo([u + l - h, f + v], h, p, !1).lineTo(u + h, f + v).arcTo([u, f + v - p], h, p, !1).lineTo(u, f + p).arcTo([u + h, f], h, p, !1);
    }
    return s;
  }, e.fromPoints = function(r, i) {
    if (r) {
      for (var s = new e(i), a = 0; a < r.length; a++) {
        var h = y.create(r[a]);
        h && (a === 0 ? s.moveTo(h) : s.lineTo(h));
      }
      return s;
    }
  }, e.curveFromPoints = function(r, i) {
    if (r) {
      var s = oo(r), a = new e(i);
      return a.segments.push.apply(a.segments, s), a;
    }
  }, e.fromArc = function(r, i) {
    var s = new e(i), a = r.startAngle, h = r.pointAt(a);
    return s.moveTo(h.x, h.y), s.arc(a, r.endAngle, r.radiusX, r.radiusY, r.anticlockwise), s;
  }, Object.defineProperties(e.prototype, n), e;
}(rr(nr(ot))), yo = function(o) {
  function e(t) {
    o.call(this, t), this.paths = new sr(), this.paths.addObserver(this), d(this.options.stroke) || this.stroke("#000");
  }
  o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e;
  var n = { nodeType: { configurable: !0 } };
  return e.parse = function(r, i) {
    var s = new e(i);
    return fo(s, r);
  }, e.prototype.toString = function(r) {
    var i = this.paths, s = "";
    if (i.length > 0) {
      for (var a = [], h = 0; h < i.length; h++)
        a.push(i[h].toString(r));
      s = a.join(St);
    }
    return s;
  }, n.nodeType.get = function() {
    return "MultiPath";
  }, e.prototype.moveTo = function(r, i) {
    var s = new yr();
    return s.moveTo(r, i), this.paths.push(s), this;
  }, e.prototype.lineTo = function(r, i) {
    return this.paths.length > 0 && w(this.paths).lineTo(r, i), this;
  }, e.prototype.curveTo = function(r, i, s) {
    return this.paths.length > 0 && w(this.paths).curveTo(r, i, s), this;
  }, e.prototype.arc = function(r, i, s, a, h) {
    return this.paths.length > 0 && w(this.paths).arc(r, i, s, a, h), this;
  }, e.prototype.arcTo = function(r, i, s, a, h, p) {
    return this.paths.length > 0 && w(this.paths).arcTo(r, i, s, a, h, p), this;
  }, e.prototype.close = function() {
    return this.paths.length > 0 && w(this.paths).close(), this;
  }, e.prototype._bbox = function(r) {
    return Tt(this.paths, !0, r);
  }, e.prototype.rawBBox = function() {
    return Tt(this.paths, !1);
  }, e.prototype._containsPoint = function(r) {
    for (var i = this.paths, s = 0; s < i.length; s++)
      if (i[s]._containsPoint(r))
        return !0;
    return !1;
  }, e.prototype._isOnPath = function(r) {
    for (var i = this.paths, s = this.options.stroke.width, a = 0; a < i.length; a++)
      if (i[a]._isOnPath(r, s))
        return !0;
    return !1;
  }, e.prototype._clippedBBox = function(r) {
    return vr(this.paths, this.currentTransform(r));
  }, Object.defineProperties(e.prototype, n), e;
}(rr(nr(ot))), mo = function(o) {
  function e(t, r, i) {
    r === void 0 && (r = new C()), i === void 0 && (i = {}), o.call(this, i), this.src(t), this.rect(r);
  }
  o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e;
  var n = { nodeType: { configurable: !0 } };
  return n.nodeType.get = function() {
    return "Image";
  }, e.prototype.src = function(r) {
    return d(r) ? (this.options.set("src", r), this) : this.options.get("src");
  }, e.prototype.bbox = function(r) {
    var i = K(this.currentTransform(r));
    return this._rect.bbox(i);
  }, e.prototype.rawBBox = function() {
    return this._rect.bbox();
  }, e.prototype._containsPoint = function(r) {
    return this._rect.containsPoint(r);
  }, e.prototype._hasFill = function() {
    return this.src();
  }, Object.defineProperties(e.prototype, n), e;
}(Dn(ot, ["rect"]));
const ns = mo;
var go = function(o, e) {
  return function(n) {
    function t() {
      n.apply(this, arguments);
    }
    return n && (t.__proto__ = n), t.prototype = Object.create(n && n.prototype), t.prototype.constructor = t, t.prototype.traverse = function(i) {
      for (var s = this[e], a = 0; a < s.length; a++) {
        var h = s[a];
        h.traverse ? h.traverse(i) : i(h);
      }
      return this;
    }, t;
  }(o);
};
const se = go;
var _o = function(o) {
  function e(t) {
    o.call(this, t), this.children = [];
  }
  o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e;
  var n = { nodeType: { configurable: !0 } };
  return n.nodeType.get = function() {
    return "Group";
  }, e.prototype.childrenChange = function(r, i, s) {
    this.trigger("childrenChange", {
      action: r,
      items: i,
      index: s
    });
  }, e.prototype.append = function() {
    return nt(this.children, arguments), this._reparent(arguments, this), this.childrenChange("add", arguments), this;
  }, e.prototype.insert = function(r, i) {
    return this.children.splice(r, 0, i), i.parent = this, this.childrenChange("add", [i], r), this;
  }, e.prototype.insertAt = function(r, i) {
    return this.insert(i, r);
  }, e.prototype.remove = function(r) {
    var i = this.children.indexOf(r);
    return i >= 0 && (this.children.splice(i, 1), r.parent = null, this.childrenChange("remove", [r], i)), this;
  }, e.prototype.removeAt = function(r) {
    if (0 <= r && r < this.children.length) {
      var i = this.children[r];
      this.children.splice(r, 1), i.parent = null, this.childrenChange("remove", [i], r);
    }
    return this;
  }, e.prototype.clear = function() {
    var r = this.children;
    return this.children = [], this._reparent(r, null), this.childrenChange("remove", r, 0), this;
  }, e.prototype.bbox = function(r) {
    return Tt(this.children, !0, this.currentTransform(r));
  }, e.prototype.rawBBox = function() {
    return Tt(this.children, !1);
  }, e.prototype._clippedBBox = function(r) {
    return vr(this.children, this.currentTransform(r));
  }, e.prototype.currentTransform = function(r) {
    return ot.prototype.currentTransform.call(this, r) || null;
  }, e.prototype.containsPoint = function(r, i) {
    if (this.visible()) {
      for (var s = this.children, a = this.currentTransform(i), h = 0; h < s.length; h++)
        if (s[h].containsPoint(r, a))
          return !0;
    }
    return !1;
  }, e.prototype._reparent = function(r, i) {
    for (var s = this, a = 0; a < r.length; a++) {
      var h = r[a], p = h.parent;
      p && p !== s && p.remove && p.remove(h), h.parent = i;
    }
  }, Object.defineProperties(e.prototype, n), e;
}(se(ot, "children"));
const dr = _o;
var bo = function(o) {
  function e() {
    o.apply(this, arguments);
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype._change = function() {
    this.optionsChange({
      field: "stops"
    });
  }, e;
}(ir);
const wo = bo;
function xo(o) {
  return function(e) {
    return d(e) ? (this.options.set(o, e), this) : this.options.get(o);
  };
}
function Co(o, e) {
  for (var n = 0; n < e.length; n++)
    o[e[n]] = xo(e[n]);
}
var To = function(o, e) {
  var n = function(t) {
    function r() {
      t.apply(this, arguments);
    }
    return t && (r.__proto__ = t), r.prototype = Object.create(t && t.prototype), r.prototype.constructor = r, r;
  }(o);
  return Co(n.prototype, e), n;
};
const So = To;
var Ao = ["offset", "color", "opacity"], Oo = function(o) {
  function e(n, t, r) {
    o.call(this), this.options = new er({
      offset: n,
      color: t,
      opacity: d(r) ? r : 1
    }), this.options.addObserver(this);
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.create = function(t) {
    if (d(t)) {
      var r;
      return t instanceof e ? r = t : t.length > 1 ? r = new e(t[0], t[1], t[2]) : r = new e(t.offset, t.color, t.opacity), r;
    }
  }, e;
}(So(E, Ao));
const De = Oo;
var Mo = function(o) {
  function e(t) {
    t === void 0 && (t = {}), o.call(this), this.stops = new wo(this._createStops(t.stops)), this.stops.addObserver(this), this._userSpace = t.userSpace, this.id = xt();
  }
  o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e;
  var n = { nodeType: { configurable: !0 } };
  return n.nodeType.get = function() {
    return "Gradient";
  }, e.prototype.userSpace = function(r) {
    return d(r) ? (this._userSpace = r, this.optionsChange(), this) : this._userSpace;
  }, e.prototype._createStops = function(r) {
    r === void 0 && (r = []);
    for (var i = [], s = 0; s < r.length; s++)
      i.push(De.create(r[s]));
    return i;
  }, e.prototype.addStop = function(r, i, s) {
    this.stops.push(new De(r, i, s));
  }, e.prototype.removeStop = function(r) {
    var i = this.stops.indexOf(r);
    i >= 0 && this.stops.splice(i, 1);
  }, e.prototype.optionsChange = function(r) {
    this.trigger("optionsChange", {
      field: "gradient" + (r ? "." + r.field : ""),
      value: this
    });
  }, e.prototype.geometryChange = function() {
    this.optionsChange();
  }, Object.defineProperties(e.prototype, n), e;
}(E);
const mr = Mo;
var Eo = ["start", "end"], ko = function(o) {
  function e(n) {
    n === void 0 && (n = {}), o.call(this, n), this.start(n.start || new y()), this.end(n.end || new y(1, 0));
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e;
}(ie(mr, Eo));
const gr = ko;
var Ro = function(o) {
  function e(n) {
    n === void 0 && (n = {}), o.call(this, n), this.center(n.center || new y()), this._radius = d(n.radius) ? n.radius : 1, this._fallbackFill = n.fallbackFill;
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.radius = function(t) {
    return d(t) ? (this._radius = t, this.geometryChange(), this) : this._radius;
  }, e.prototype.fallbackFill = function(t) {
    return d(t) ? (this._fallbackFill = t, this.optionsChange(), this) : this._fallbackFill;
  }, e;
}(ie(mr, ["center"]));
const _r = Ro;
var $o = function(o) {
  function e(n) {
    o.call(this), this.childNodes = [], this.parent = null, n && (this.srcElement = n, this.observe());
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.destroy = function() {
    var t = this;
    this.srcElement && this.srcElement.removeObserver(this);
    for (var r = this.childNodes, i = 0; i < r.length; i++)
      t.childNodes[i].destroy();
    this.parent = null;
  }, e.prototype.load = function() {
  }, e.prototype.observe = function() {
    this.srcElement && this.srcElement.addObserver(this);
  }, e.prototype.append = function(t) {
    this.childNodes.push(t), t.parent = this;
  }, e.prototype.insertAt = function(t, r) {
    this.childNodes.splice(r, 0, t), t.parent = this;
  }, e.prototype.remove = function(t, r) {
    for (var i = this, s = t + r, a = t; a < s; a++)
      i.childNodes[a].removeSelf();
    this.childNodes.splice(t, r);
  }, e.prototype.removeSelf = function() {
    this.clear(), this.destroy();
  }, e.prototype.clear = function() {
    this.remove(0, this.childNodes.length);
  }, e.prototype.invalidate = function() {
    this.parent && this.parent.invalidate();
  }, e.prototype.geometryChange = function() {
    this.invalidate();
  }, e.prototype.optionsChange = function() {
    this.invalidate();
  }, e.prototype.childrenChange = function(t) {
    t.action === "add" ? this.load(t.items, t.index) : t.action === "remove" && this.remove(t.index, t.items.length), this.invalidate();
  }, e;
}(S);
const kt = $o;
var Po = [
  "click",
  "mouseenter",
  "mouseleave",
  "mousemove",
  "resize"
], Io = function(o) {
  function e(n, t) {
    o.call(this), this.options = Object.assign({}, t), this.element = n, this.element._kendoExportVisual = this.exportVisual.bind(this), this._click = this._handler("click"), this._mouseenter = this._handler("mouseenter"), this._mouseleave = this._handler("mouseleave"), this._mousemove = this._handler("mousemove"), this._visual = new dr(), et(n, this.options), this.bind(Po, this.options), this._enableTracking();
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.draw = function(t) {
    this._visual.children.push(t);
  }, e.prototype.clear = function() {
    this._visual.children = [];
  }, e.prototype.destroy = function() {
    this._visual = null, this.element._kendoExportVisual = null, this.unbind();
  }, e.prototype.eventTarget = function(t) {
    for (var r = this, i = Ue(t), s; !s && i && (s = i._kendoNode, i !== r.element); )
      i = i.parentElement;
    if (s)
      return s.srcElement;
  }, e.prototype.exportVisual = function() {
    return this._visual;
  }, e.prototype.getSize = function() {
    return et(this.element);
  }, e.prototype.currentSize = function(t) {
    if (t)
      this._size = t;
    else
      return this._size;
  }, e.prototype.setSize = function(t) {
    et(this.element, t), this.currentSize(t), this._resize();
  }, e.prototype.resize = function(t) {
    var r = this.getSize(), i = this.currentSize();
    (t || (r.width > 0 || r.height > 0) && (!i || r.width !== i.width || r.height !== i.height)) && (this.currentSize(r), this._resize(r, t), this.trigger("resize", r));
  }, e.prototype.size = function(t) {
    if (!t)
      return this.getSize();
    this.setSize(t);
  }, e.prototype.suspendTracking = function() {
    this._suspendedTracking = !0;
  }, e.prototype.resumeTracking = function() {
    this._suspendedTracking = !1;
  }, e.prototype._enableTracking = function() {
  }, e.prototype._resize = function() {
  }, e.prototype._handler = function(t) {
    var r = this;
    return function(i) {
      var s = r.eventTarget(i);
      s && !r._suspendedTracking && r.trigger(t, {
        element: s,
        originalEvent: i,
        type: t
      });
    };
  }, e.prototype._elementOffset = function() {
    var t = this.element, r = We(t), i = Ye(t), s = i.left, a = i.top;
    return {
      left: s + r.left,
      top: a + r.top
    };
  }, e.prototype._surfacePoint = function(t) {
    var r = this._elementOffset(), i = Ve(t), s = i.x - r.left, a = i.y - r.top, h = Ze(this.element).invert(), p = new y(
      s,
      a
    ).transform(h);
    return p;
  }, e;
}(Gr);
const ae = Io;
function H(o, e) {
  return d(e) && e !== null ? " " + o + '="' + e + '" ' : "";
}
function V(o) {
  for (var e = "", n = 0; n < o.length; n++)
    e += H(o[n][0], o[n][1]);
  return e;
}
function br(o) {
  for (var e = "", n = 0; n < o.length; n++) {
    var t = o[n][1];
    d(t) && (e += o[n][0] + ":" + t + ";");
  }
  if (e !== "")
    return e;
}
var Lo = {};
const L = Lo;
var At = "http://www.w3.org/2000/svg", Ot = "none", he = 3, Do = function(o, e) {
  return o.split(";").filter(function(n) {
    return n !== "";
  }).forEach(function(n) {
    var t = n.split(":");
    e.style[t[0].trim()] = t[1].trim();
  });
}, _t = "data-style", wr = function(o) {
  return o.replace(/\sstyle=/g, " " + _t + "=");
}, xr = function(o) {
  Array.from(o.querySelectorAll("[" + _t + "]")).forEach(function(e) {
    var n = e.getAttribute(_t);
    e.removeAttribute(_t), Do(n, e);
  });
}, Cr = function(o, e) {
  o.innerHTML = wr(e), xr(o);
};
if (typeof document < "u") {
  var jo = "<svg xmlns='" + At + "'></svg>", je = document.createElement("div"), zo = typeof DOMParser < "u";
  je.innerHTML = jo, zo && je.firstChild.namespaceURI !== At && (Cr = function(o, e) {
    var n = new DOMParser(), t = n.parseFromString(wr(e), "text/xml");
    xr(t);
    var r = document.adoptNode(t.documentElement);
    o.innerHTML = "", o.appendChild(r);
  });
}
const Tr = Cr;
var ze = "transform", mt = {
  clip: "clip-path",
  fill: "fill"
};
function Fe(o, e) {
  return o === "clip" || o === "fill" && (!e || e.nodeType === "Gradient");
}
function Fo() {
  var o = document.getElementsByTagName("base")[0], e = document.location.href, n = "";
  if (o && !(bt.browser || {}).msie) {
    var t = e.indexOf("#");
    t !== -1 && (e = e.substring(0, t)), n = e;
  }
  return n;
}
var Go = function(o) {
  function e(n, t) {
    o.call(this, n), this.definitions = {}, this.options = t;
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.destroy = function() {
    this.element && (this.element._kendoNode = null, this.element = null), this.clearDefinitions(), o.prototype.destroy.call(this);
  }, e.prototype.load = function(t, r) {
    for (var i = this, s = 0; s < t.length; s++) {
      var a = t[s], h = a.children, p = new L[a.nodeType](a, i.options);
      d(r) ? i.insertAt(p, r) : i.append(p), p.createDefinitions(), h && h.length > 0 && p.load(h);
      var c = i.element;
      c && p.attachTo(c, r);
    }
  }, e.prototype.root = function() {
    for (var t = this; t.parent; )
      t = t.parent;
    return t;
  }, e.prototype.attachTo = function(t, r) {
    var i = document.createElement("div");
    Tr(
      i,
      "<svg xmlns='" + At + "' version='1.1'>" + this.render() + "</svg>"
    );
    var s = i.firstChild.firstChild;
    s && (d(r) ? t.insertBefore(s, t.childNodes[r] || null) : t.appendChild(s), this.setElement(s));
  }, e.prototype.setElement = function(t) {
    this.element && (this.element._kendoNode = null), this.element = t, this.element._kendoNode = this;
    for (var r = this.childNodes, i = 0; i < r.length; i++) {
      var s = t.childNodes[i];
      r[i].setElement(s);
    }
  }, e.prototype.clear = function() {
    this.clearDefinitions(), this.element && (this.element.innerHTML = "");
    for (var t = this.childNodes, r = 0; r < t.length; r++)
      t[r].destroy();
    this.childNodes = [];
  }, e.prototype.removeSelf = function() {
    if (this.element) {
      var t = this.element.parentNode;
      t && t.removeChild(this.element), this.element = null;
    }
    o.prototype.removeSelf.call(this);
  }, e.prototype.template = function() {
    return this.renderChildren();
  }, e.prototype.render = function() {
    return this.template();
  }, e.prototype.renderChildren = function() {
    for (var t = this.childNodes, r = "", i = 0; i < t.length; i++)
      r += t[i].render();
    return r;
  }, e.prototype.optionsChange = function(t) {
    var r = t.field, i = t.value;
    r === "visible" ? this.css("display", i ? "" : Ot) : mt[r] && Fe(r, i) ? this.updateDefinition(r, i) : r === "opacity" ? this.attr("opacity", i) : r === "cursor" ? this.css("cursor", i) : r === "id" && (i ? this.attr("id", i) : this.removeAttr("id")), o.prototype.optionsChange.call(this, t);
  }, e.prototype.attr = function(t, r) {
    this.element && this.element.setAttribute(t, r);
  }, e.prototype.allAttr = function(t) {
    for (var r = this, i = 0; i < t.length; i++)
      r.attr(t[i][0], t[i][1]);
  }, e.prototype.css = function(t, r) {
    this.element && (this.element.style[t] = r);
  }, e.prototype.allCss = function(t) {
    for (var r = this, i = 0; i < t.length; i++)
      r.css(t[i][0], t[i][1]);
  }, e.prototype.removeAttr = function(t) {
    this.element && this.element.removeAttribute(t);
  }, e.prototype.mapTransform = function(t) {
    var r = [];
    return t && r.push([
      ze,
      "matrix(" + t.matrix().toString(6) + ")"
    ]), r;
  }, e.prototype.renderTransform = function() {
    return V(
      this.mapTransform(this.srcElement.transform())
    );
  }, e.prototype.transformChange = function(t) {
    t ? this.allAttr(this.mapTransform(t)) : this.removeAttr(ze);
  }, e.prototype.mapStyle = function() {
    var t = this.srcElement.options, r = [["cursor", t.cursor]];
    return t.visible === !1 && r.push(["display", Ot]), r;
  }, e.prototype.renderStyle = function() {
    return H("style", br(this.mapStyle(!0)));
  }, e.prototype.renderOpacity = function() {
    return H("opacity", this.srcElement.options.opacity);
  }, e.prototype.renderId = function() {
    return H("id", this.srcElement.options.id);
  }, e.prototype.createDefinitions = function() {
    var t = this.srcElement, r = this.definitions;
    if (t) {
      var i = t.options, s;
      for (var a in mt) {
        var h = i.get(a);
        h && Fe(a, h) && (r[a] = h, s = !0);
      }
      s && this.definitionChange({
        action: "add",
        definitions: r
      });
    }
  }, e.prototype.definitionChange = function(t) {
    this.parent && this.parent.definitionChange(t);
  }, e.prototype.updateDefinition = function(t, r) {
    var i = this.definitions, s = i[t], a = mt[t], h = {};
    s && (h[t] = s, this.definitionChange({
      action: "remove",
      definitions: h
    }), delete i[t]), r ? (h[t] = r, this.definitionChange({
      action: "add",
      definitions: h
    }), i[t] = r, this.attr(a, this.refUrl(r.id))) : s && this.removeAttr(a);
  }, e.prototype.clearDefinitions = function() {
    var t = this.definitions;
    this.definitionChange({
      action: "remove",
      definitions: t
    }), this.definitions = {};
  }, e.prototype.renderDefinitions = function() {
    return V(this.mapDefinitions());
  }, e.prototype.mapDefinitions = function() {
    var t = this, r = this.definitions, i = [];
    for (var s in r)
      i.push([mt[s], t.refUrl(r[s].id)]);
    return i;
  }, e.prototype.refUrl = function(t) {
    var r = (this.options || {}).skipBaseHref, i = this.baseUrl().replace(/'/g, "\\'"), s = r ? "" : i;
    return "url(" + s + "#" + t + ")";
  }, e.prototype.baseUrl = function() {
    return Fo();
  }, e;
}(kt);
const U = Go;
var qo = function(o) {
  function e() {
    o.apply(this, arguments);
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.template = function() {
    return "<stop " + this.renderOffset() + " " + this.renderStyle() + " />";
  }, e.prototype.renderOffset = function() {
    return H("offset", this.srcElement.offset());
  }, e.prototype.mapStyle = function() {
    var t = this.srcElement;
    return [
      ["stop-color", t.color()],
      ["stop-opacity", t.opacity()]
    ];
  }, e.prototype.optionsChange = function(t) {
    t.field === "offset" ? this.attr(t.field, t.value) : (t.field === "color" || t.field === "opacity") && this.css("stop-" + t.field, t.value);
  }, e;
}(U);
const Bo = qo;
var Ho = function(o) {
  function e(n) {
    o.call(this, n), this.id = n.id, this.loadStops();
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.loadStops = function() {
    for (var t = this, r = this.srcElement.stops, i = this.element, s = 0; s < r.length; s++) {
      var a = new Bo(r[s]);
      t.append(a), i && a.attachTo(i);
    }
  }, e.prototype.optionsChange = function(t) {
    t.field === "gradient.stops" ? (kt.prototype.clear.call(this), this.loadStops()) : t.field === "gradient" && this.allAttr(this.mapCoordinates());
  }, e.prototype.renderCoordinates = function() {
    return V(this.mapCoordinates());
  }, e.prototype.mapSpace = function() {
    return ["gradientUnits", this.srcElement.userSpace() ? "userSpaceOnUse" : "objectBoundingBox"];
  }, e;
}(U);
const Sr = Ho;
var No = function(o) {
  function e() {
    o.apply(this, arguments);
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.template = function() {
    return "<linearGradient id='" + this.id + "' " + this.renderCoordinates() + ">" + this.renderChildren() + "</linearGradient>";
  }, e.prototype.mapCoordinates = function() {
    var t = this.srcElement, r = t.start(), i = t.end(), s = [
      ["x1", r.x],
      ["y1", r.y],
      ["x2", i.x],
      ["y2", i.y],
      this.mapSpace()
    ];
    return s;
  }, e;
}(Sr);
const Vo = No;
var Uo = function(o) {
  function e() {
    o.apply(this, arguments);
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.template = function() {
    return "<radialGradient id='" + this.id + "' " + this.renderCoordinates() + ">" + this.renderChildren() + "</radialGradient>";
  }, e.prototype.mapCoordinates = function() {
    var t = this.srcElement, r = t.center(), i = t.radius(), s = [
      ["cx", r.x],
      ["cy", r.y],
      ["r", i],
      this.mapSpace()
    ];
    return s;
  }, e;
}(Sr);
const Xo = Uo;
var Yo = function(o) {
  function e(n) {
    o.call(this), this.srcElement = n, this.id = n.id, this.load([n]);
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.template = function() {
    return "<clipPath id='" + this.id + "'>" + this.renderChildren() + "</clipPath>";
  }, e;
}(U);
const Wo = Yo;
var Zo = function(o) {
  function e() {
    o.call(this), this.definitionMap = {};
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.attachTo = function(t) {
    this.element = t;
  }, e.prototype.template = function() {
    return "<defs>" + this.renderChildren() + "</defs>";
  }, e.prototype.definitionChange = function(t) {
    var r = t.definitions, i = t.action;
    i === "add" ? this.addDefinitions(r) : i === "remove" && this.removeDefinitions(r);
  }, e.prototype.createDefinition = function(t, r) {
    var i;
    return t === "clip" ? i = Wo : t === "fill" && (r instanceof gr ? i = Vo : r instanceof _r && (i = Xo)), new i(r);
  }, e.prototype.addDefinitions = function(t) {
    var r = this;
    for (var i in t)
      r.addDefinition(i, t[i]);
  }, e.prototype.addDefinition = function(t, r) {
    var i = this, s = i.element, a = i.definitionMap, h = r.id, p = a[h];
    if (p)
      p.count++;
    else {
      var c = this.createDefinition(t, r);
      a[h] = {
        element: c,
        count: 1
      }, this.append(c), s && c.attachTo(this.element);
    }
  }, e.prototype.removeDefinitions = function(t) {
    var r = this;
    for (var i in t)
      r.removeDefinition(t[i]);
  }, e.prototype.removeDefinition = function(t) {
    var r = this.definitionMap, i = t.id, s = r[i];
    s && (s.count--, s.count === 0 && (this.remove(this.childNodes.indexOf(s.element), 1), delete r[i]));
  }, e;
}(U);
const Jo = Zo;
var Ko = function(o) {
  function e(n) {
    o.call(this), this.options = n, this.defs = new Jo();
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.attachTo = function(t) {
    this.element = t, this.defs.attachTo(t.firstElementChild);
  }, e.prototype.clear = function() {
    kt.prototype.clear.call(this);
  }, e.prototype.template = function() {
    return this.defs.render() + this.renderChildren();
  }, e.prototype.definitionChange = function(t) {
    this.defs.definitionChange(t);
  }, e;
}(U);
const Qo = Ko;
var Ar = {
  dot: [1.5, 3.5],
  dash: [4, 3.5],
  longdash: [8, 3.5],
  dashdot: [3.5, 3.5, 1.5, 3.5],
  longdashdot: [8, 3.5, 1.5, 3.5],
  longdashdotdot: [8, 3.5, 1.5, 3.5, 1.5, 3.5]
}, Wt = "solid", Or = "butt", ti = {
  "fill.opacity": "fill-opacity",
  "stroke.color": "stroke",
  "stroke.width": "stroke-width",
  "stroke.opacity": "stroke-opacity"
}, ei = function(o) {
  function e() {
    o.apply(this, arguments);
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.geometryChange = function() {
    this.attr("d", this.renderData()), this.invalidate();
  }, e.prototype.optionsChange = function(t) {
    switch (t.field) {
      case "fill":
        t.value ? this.allAttr(this.mapFill(t.value)) : this.removeAttr("fill");
        break;
      case "fill.color":
        this.allAttr(this.mapFill({ color: t.value }));
        break;
      case "stroke":
        t.value ? this.allAttr(this.mapStroke(t.value)) : this.removeAttr("stroke");
        break;
      case "transform":
        this.transformChange(t.value);
        break;
      default:
        var r = ti[t.field];
        r && this.attr(r, t.value);
        break;
    }
    o.prototype.optionsChange.call(this, t);
  }, e.prototype.content = function() {
    this.element && (this.element.textContent = this.srcElement.content());
  }, e.prototype.renderData = function() {
    return this.srcElement.toString(he) || void 0;
  }, e.prototype.mapStroke = function(t) {
    var r = [];
    return t && !N(t.color) ? (r.push(["stroke", t.color]), r.push(["stroke-width", t.width]), r.push(["stroke-linecap", this.renderLinecap(t)]), r.push(["stroke-linejoin", t.lineJoin]), d(t.opacity) && r.push(["stroke-opacity", t.opacity]), d(t.dashType) && r.push(["stroke-dasharray", this.renderDashType(t)])) : r.push(["stroke", Ot]), r;
  }, e.prototype.renderStroke = function() {
    return V(
      this.mapStroke(this.srcElement.options.stroke)
    );
  }, e.prototype.renderDashType = function(t) {
    var r = t.dashType, i = t.width;
    if (i === void 0 && (i = 1), r && r !== Wt) {
      for (var s = Ar[r.toLowerCase()], a = [], h = 0; h < s.length; h++)
        a.push(s[h] * i);
      return a.join(" ");
    }
  }, e.prototype.renderLinecap = function(t) {
    var r = t.dashType, i = t.lineCap;
    return r && r !== "solid" ? Or : i;
  }, e.prototype.mapFill = function(t) {
    var r = [];
    return t && t.nodeType === "Gradient" || (t && !N(t.color) ? (r.push(["fill", t.color]), d(t.opacity) && r.push(["fill-opacity", t.opacity])) : r.push(["fill", Ot])), r;
  }, e.prototype.renderFill = function() {
    return V(
      this.mapFill(this.srcElement.options.fill)
    );
  }, e.prototype.template = function() {
    return "<path " + this.renderId() + " " + this.renderStyle() + " " + this.renderOpacity() + " " + H("d", this.renderData()) + this.renderStroke() + this.renderFill() + this.renderDefinitions() + this.renderTransform() + "></path>";
  }, e;
}(U);
const X = ei;
var ri = function(o) {
  function e() {
    o.apply(this, arguments);
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.renderData = function() {
    return this.srcElement.toPath().toString(he);
  }, e;
}(X);
const ni = ri;
var oi = function(o) {
  function e() {
    o.apply(this, arguments);
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.geometryChange = function() {
    var t = this.center();
    this.attr("cx", t.x), this.attr("cy", t.y), this.attr("r", this.radius()), this.invalidate();
  }, e.prototype.center = function() {
    return this.srcElement.geometry().center;
  }, e.prototype.radius = function() {
    return this.srcElement.geometry().radius;
  }, e.prototype.template = function() {
    return "<circle " + this.renderId() + " " + this.renderStyle() + " " + this.renderOpacity() + "cx='" + this.center().x + "' cy='" + this.center().y + "' r='" + this.radius() + "'" + this.renderStroke() + " " + this.renderFill() + " " + this.renderDefinitions() + this.renderTransform() + " ></circle>";
  }, e;
}(X);
const ii = oi;
var si = function(o) {
  function e() {
    o.apply(this, arguments);
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.template = function() {
    return "<g" + (this.renderId() + this.renderTransform() + this.renderStyle() + this.renderOpacity() + this.renderDefinitions()) + ">" + this.renderChildren() + "</g>";
  }, e.prototype.optionsChange = function(t) {
    t.field === "transform" && this.transformChange(t.value), o.prototype.optionsChange.call(this, t);
  }, e;
}(U);
const ai = si;
var hi = function(o) {
  function e() {
    o.apply(this, arguments);
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.geometryChange = function() {
    this.allAttr(this.mapPosition()), this.invalidate();
  }, e.prototype.optionsChange = function(t) {
    t.field === "src" && this.allAttr(this.mapSource()), o.prototype.optionsChange.call(this, t);
  }, e.prototype.mapPosition = function() {
    var t = this.srcElement.rect(), r = t.topLeft();
    return [
      ["x", r.x],
      ["y", r.y],
      ["width", t.width() + "px"],
      ["height", t.height() + "px"]
    ];
  }, e.prototype.renderPosition = function() {
    return V(this.mapPosition());
  }, e.prototype.mapSource = function(t) {
    var r = this.srcElement.src();
    return t && (r = Gt(r)), [["xlink:href", r]];
  }, e.prototype.renderSource = function() {
    return V(this.mapSource(!0));
  }, e.prototype.template = function() {
    return "<image preserveAspectRatio='none' " + this.renderId() + " " + this.renderStyle() + " " + this.renderTransform() + " " + this.renderOpacity() + this.renderPosition() + " " + this.renderSource() + " " + this.renderDefinitions() + "></image>";
  }, e;
}(X);
const pi = hi;
var ci = function(o) {
  function e() {
    o.apply(this, arguments);
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.renderData = function() {
    return this.srcElement.toString(he) || "undefined";
  }, e;
}(X);
const ui = ci;
var fi = function(o) {
  function e() {
    o.apply(this, arguments);
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.geometryChange = function() {
    var t = this.srcElement.geometry();
    this.attr("x", t.origin.x), this.attr("y", t.origin.y), this.attr("width", t.size.width), this.attr("height", t.size.height), this.attr("rx", t.cornerRadius[0]), this.attr("ry", t.cornerRadius[1]), this.invalidate();
  }, e.prototype.size = function() {
    return this.srcElement.geometry().size;
  }, e.prototype.origin = function() {
    return this.srcElement.geometry().origin;
  }, e.prototype.rx = function() {
    return this.srcElement.geometry().cornerRadius[0];
  }, e.prototype.ry = function() {
    return this.srcElement.geometry().cornerRadius[1];
  }, e.prototype.template = function() {
    return "<rect " + this.renderId() + " " + this.renderStyle() + " " + this.renderOpacity() + " x='" + this.origin().x + "' y='" + this.origin().y + "' rx='" + this.rx() + "' ry='" + this.ry() + "' width='" + this.size().width + "' height='" + this.size().height + "' " + this.renderStroke() + " " + this.renderFill() + " " + this.renderDefinitions() + " " + this.renderTransform() + " />";
  }, e;
}(X);
const li = fi;
var Dt = /&(?:[a-zA-Z]+|#\d+);/g;
function pe(o) {
  if (!o || typeof o != "string" || !Dt.test(o))
    return o;
  var e = pe._element;
  return Dt.lastIndex = 0, o.replace(Dt, function(n) {
    return e.innerHTML = n, e.textContent || e.innerText;
  });
}
typeof document < "u" && (pe._element = document.createElement("span"));
var vi = function(o) {
  function e() {
    o.apply(this, arguments);
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.geometryChange = function() {
    var t = this.pos();
    this.attr("x", t.x), this.attr("y", t.y), this.invalidate();
  }, e.prototype.optionsChange = function(t) {
    t.field === "font" ? (this.attr("style", br(this.mapStyle())), this.geometryChange()) : t.field === "content" && o.prototype.content.call(this, this.srcElement.content()), o.prototype.optionsChange.call(this, t);
  }, e.prototype.mapStyle = function(t) {
    var r = o.prototype.mapStyle.call(this, t), i = this.srcElement.options.font;
    return t && (i = Gt(i)), r.push(["font", i], ["white-space", "pre"]), r;
  }, e.prototype.pos = function() {
    var t = this.srcElement.position(), r = this.srcElement.measure();
    return t.clone().setY(t.y + r.baseline);
  }, e.prototype.renderContent = function() {
    var t = this.srcElement.content();
    return t = pe(t), t = Gt(t), ne(t);
  }, e.prototype.renderTextAnchor = function() {
    var t;
    return (this.options || {}).rtl && !(bt.browser.msie || bt.browser.edge) && (t = "end"), H("text-anchor", t);
  }, e.prototype.template = function() {
    return "<text " + this.renderId() + " " + this.renderTextAnchor() + " " + this.renderStyle() + " " + this.renderOpacity() + "x='" + this.pos().x + "' y='" + this.pos().y + "' " + this.renderStroke() + " " + this.renderTransform() + " " + this.renderDefinitions() + this.renderFill() + ">" + this.renderContent() + "</text>";
  }, e;
}(X);
const yi = vi;
L.Arc = ni;
L.Circle = ii;
L.Group = ai;
L.Image = pi;
L.MultiPath = ui;
L.Path = X;
L.Rect = li;
L.Text = yi;
var di = "rtl";
function mi(o) {
  var e;
  try {
    e = o.getScreenCTM ? o.getScreenCTM() : null;
  } catch {
  }
  if (e) {
    var n = -e.e % 1, t = -e.f % 1, r = o.style;
    (n !== 0 || t !== 0) && (r.left = n + "px", r.top = t + "px");
  }
}
var gi = function(o) {
  function e(t, r) {
    o.call(this, t, r), this._root = new Qo(Object.assign({
      rtl: Et(t, "direction").direction === di
    }, this.options)), Tr(this.element, this._template("")), this._rootElement = this.element.firstElementChild, this._rootElement.style.width = "100%", this._rootElement.style.height = "100%", this._rootElement.style.overflow = "hidden", mi(this._rootElement), this._root.attachTo(this._rootElement), ee(this.element, {
      click: this._click,
      mouseover: this._mouseenter,
      mouseout: this._mouseleave,
      mousemove: this._mousemove
    }), this.resize();
  }
  o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e;
  var n = { type: { configurable: !0 } };
  return n.type.get = function() {
    return "svg";
  }, e.prototype.destroy = function() {
    this._root && (this._root.destroy(), this._root = null, this._rootElement = null, re(this.element, {
      click: this._click,
      mouseover: this._mouseenter,
      mouseout: this._mouseleave,
      mousemove: this._mousemove
    })), o.prototype.destroy.call(this);
  }, e.prototype.translate = function(r) {
    var i = Math.round(r.x) + " " + Math.round(r.y) + " " + this._size.width + " " + this._size.height;
    this._offset = r, this._rootElement.setAttribute("viewBox", i);
  }, e.prototype.draw = function(r) {
    o.prototype.draw.call(this, r), this._root.load([r]);
  }, e.prototype.clear = function() {
    o.prototype.clear.call(this), this._root.clear();
  }, e.prototype.svg = function() {
    return "<?xml version='1.0' ?>" + this._template();
  }, e.prototype.exportVisual = function() {
    var r = this, i = r._visual, s = r._offset;
    if (s) {
      var a = new dr();
      a.children.push(i), a.transform(
        P().translate(-s.x, -s.y)
      ), i = a;
    }
    return i;
  }, e.prototype._resize = function() {
    this._offset && this.translate(this._offset);
  }, e.prototype._template = function(r) {
    var i = typeof r == "string" ? r : "style='width: 100%; height: 100%; overflow: hidden;' ";
    return "<svg " + i + "xmlns='" + At + "' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1'>" + this._root.render() + "</svg>";
  }, Object.defineProperties(e.prototype, n), e;
}(ae);
const _i = gi;
var bi = {};
const D = bi;
function Rt(o, e) {
  var n = e.segments;
  if (n.length !== 0) {
    var t = n[0], r = t.anchor();
    o.moveTo(r.x, r.y);
    for (var i = 1; i < n.length; i++) {
      t = n[i], r = t.anchor();
      var s = n[i - 1], a = s.controlOut(), h = t.controlIn();
      a && h ? o.bezierCurveTo(
        a.x,
        a.y,
        h.x,
        h.y,
        r.x,
        r.y
      ) : o.lineTo(r.x, r.y);
    }
    e.options.closed && o.closePath();
  }
}
var wi = function(o) {
  function e(n) {
    o.call(this, n), n && this.initClip();
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.initClip = function() {
    var t = this.srcElement.clip();
    t && (this.clip = t, t.addObserver(this));
  }, e.prototype.clear = function() {
    this.srcElement && this.srcElement.removeObserver(this), this.clearClip(), o.prototype.clear.call(this);
  }, e.prototype.clearClip = function() {
    this.clip && (this.clip.removeObserver(this), delete this.clip);
  }, e.prototype.setClip = function(t) {
    this.clip && (t.beginPath(), Rt(t, this.clip), t.clip());
  }, e.prototype.optionsChange = function(t) {
    t.field === "clip" && (this.clearClip(), this.initClip()), o.prototype.optionsChange.call(this, t);
  }, e.prototype.setTransform = function(t) {
    if (this.srcElement) {
      var r = this.srcElement.transform();
      r && t.transform.apply(t, r.matrix().toArray(6));
    }
  }, e.prototype.loadElements = function(t, r, i) {
    for (var s = this, a = 0; a < t.length; a++) {
      var h = t[a], p = h.children, c = new D[h.nodeType](h, i);
      p && p.length > 0 && c.load(p, r, i), d(r) ? s.insertAt(c, r) : s.append(c);
    }
  }, e.prototype.load = function(t, r, i) {
    this.loadElements(t, r, i), this.invalidate();
  }, e.prototype.setOpacity = function(t) {
    if (this.srcElement) {
      var r = this.srcElement.opacity();
      d(r) && this.globalAlpha(t, r);
    }
  }, e.prototype.globalAlpha = function(t, r) {
    var i = r;
    i && t.globalAlpha && (i *= t.globalAlpha), t.globalAlpha = i;
  }, e.prototype.visible = function() {
    var t = this.srcElement;
    return !t || t && t.options.visible !== !1;
  }, e;
}(kt);
const Mr = wi;
var xi = function(o) {
  function e() {
    o.apply(this, arguments);
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.renderTo = function(t) {
    if (this.visible()) {
      t.save(), this.setTransform(t), this.setClip(t), this.setOpacity(t);
      for (var r = this.childNodes, i = 0; i < r.length; i++) {
        var s = r[i];
        s.visible() && s.renderTo(t);
      }
      t.restore();
    }
  }, e;
}(se(Mr, "childNodes"));
const Er = xi;
var Ci = 1e3 / 60, Ti = function(o) {
  function e(n, t) {
    o.call(this), this.canvas = n, this.size = t, this.ctx = n.getContext("2d");
    var r = this._invalidate.bind(this);
    this.invalidate = Jr(function() {
      qr(r);
    }, Ci);
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.destroy = function() {
    o.prototype.destroy.call(this), this.canvas = null, this.ctx = null;
  }, e.prototype.load = function(t, r, i) {
    this.loadElements(t, r, i), this._invalidate();
  }, e.prototype._rescale = function(t) {
    var r = this, i = r.canvas, s = r.size;
    i.width = s.width * t, i.height = s.height * t, this.ctx.scale(t, t);
  }, e.prototype._devicePixelRatio = function() {
    return typeof window.devicePixelRatio == "number" ? window.devicePixelRatio : 1;
  }, e.prototype._invalidate = function(t) {
    if (this.ctx) {
      var r = t && t.fixedScale, i = r ? 1 : this._devicePixelRatio();
      this._rescale(i), this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height), this.renderTo(this.ctx);
    }
  }, e;
}(se(Er, "childNodes"));
const Si = Ti;
var Ai = function(o) {
  function e() {
    o.call(this), this.shapes = [];
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype._add = function(t, r) {
    this.shapes.push({
      bbox: r,
      shape: t
    }), t._quadNode = this;
  }, e.prototype.pointShapes = function(t) {
    for (var r = this.shapes, i = r.length, s = [], a = 0; a < i; a++)
      r[a].bbox.containsPoint(t) && s.push(r[a].shape);
    return s;
  }, e.prototype.insert = function(t, r) {
    this._add(t, r);
  }, e.prototype.remove = function(t) {
    for (var r = this.shapes, i = r.length, s = 0; s < i; s++)
      if (r[s].shape === t) {
        r.splice(s, 1);
        break;
      }
  }, e;
}(S);
const kr = Ai;
var Oi = function(o) {
  function e(n) {
    o.call(this), this.children = [], this.rect = n;
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.inBounds = function(t) {
    var r = this.rect, i = r.bottomRight(), s = t.bottomRight(), a = r.origin.x <= t.origin.x && r.origin.y <= t.origin.y && s.x <= i.x && s.y <= i.y;
    return a;
  }, e.prototype.pointShapes = function(t) {
    for (var r = this.children, i = r.length, s = o.prototype.pointShapes.call(this, t), a = 0; a < i; a++)
      nt(s, r[a].pointShapes(t));
    return s;
  }, e.prototype.insert = function(t, r) {
    var i = this.children, s = !1;
    if (this.inBounds(r)) {
      if (this.shapes.length < 4)
        this._add(t, r);
      else {
        i.length || this._initChildren();
        for (var a = 0; a < i.length; a++)
          if (i[a].insert(t, r)) {
            s = !0;
            break;
          }
        s || this._add(t, r);
      }
      s = !0;
    }
    return s;
  }, e.prototype._initChildren = function() {
    var t = this, r = t.rect, i = t.children, s = r.center(), a = r.width() / 2, h = r.height() / 2;
    i.push(
      new e(new C([r.origin.x, r.origin.y], [a, h])),
      new e(new C([s.x, r.origin.y], [a, h])),
      new e(new C([r.origin.x, s.y], [a, h])),
      new e(new C([s.x, s.y], [a, h]))
    );
  }, e;
}(kr);
const Mi = Oi;
var k = 3e3, Ge = 1e4, Ei = 75, ki = function(o) {
  function e() {
    o.call(this), this.initRoots();
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.initRoots = function() {
    this.rootMap = {}, this.root = new kr(), this.rootElements = [];
  }, e.prototype.clear = function() {
    for (var t = this, r = this.rootElements, i = 0; i < r.length; i++)
      t.remove(r[i]);
    this.initRoots();
  }, e.prototype.pointShape = function(t) {
    var r = (this.rootMap[Math.floor(t.x / k)] || {})[Math.floor(t.y / k)], i = this.root.pointShapes(t);
    r && (i = i.concat(r.pointShapes(t))), this.assignZindex(i), i.sort(Ri);
    for (var s = 0; s < i.length; s++)
      if (i[s].containsPoint(t))
        return i[s];
  }, e.prototype.assignZindex = function(t) {
    for (var r = this, i = 0; i < t.length; i++) {
      for (var s = t[i], a = 0, h = Math.pow(Ge, Ei), p = []; s; )
        p.push(s), s = s.parent;
      for (; p.length; )
        s = p.pop(), a += ((s.parent ? s.parent.children : r.rootElements).indexOf(s) + 1) * h, h /= Ge;
      t[i]._zIndex = a;
    }
  }, e.prototype.optionsChange = function(t) {
    (t.field === "transform" || t.field === "stroke.width") && this.bboxChange(t.element);
  }, e.prototype.geometryChange = function(t) {
    this.bboxChange(t.element);
  }, e.prototype.bboxChange = function(t) {
    var r = this;
    if (t.nodeType === "Group")
      for (var i = 0; i < t.children.length; i++)
        r.bboxChange(t.children[i]);
    else
      t._quadNode && t._quadNode.remove(t), this._insertShape(t);
  }, e.prototype.add = function(t) {
    var r = Array.isArray(t) ? t.slice(0) : [t];
    nt(this.rootElements, r), this._insert(r);
  }, e.prototype.childrenChange = function(t) {
    var r = this;
    if (t.action === "remove")
      for (var i = 0; i < t.items.length; i++)
        r.remove(t.items[i]);
    else
      this._insert(Array.prototype.slice.call(t.items, 0));
  }, e.prototype._insert = function(t) {
    for (var r = this, i; t.length > 0; )
      i = t.pop(), i.addObserver(r), i.nodeType === "Group" ? nt(t, i.children) : r._insertShape(i);
  }, e.prototype._insertShape = function(t) {
    var r = t.bbox();
    if (r) {
      var i = this.getSectors(r), s = i[0][0], a = i[1][0];
      if (this.inRoot(i))
        this.root.insert(t, r);
      else {
        var h = this.rootMap;
        h[s] || (h[s] = {}), h[s][a] || (h[s][a] = new Mi(
          new C([s * k, a * k], [k, k])
        )), h[s][a].insert(t, r);
      }
    }
  }, e.prototype.remove = function(t) {
    var r = this;
    if (t.removeObserver(this), t.nodeType === "Group")
      for (var i = t.children, s = 0; s < i.length; s++)
        r.remove(i[s]);
    else
      t._quadNode && (t._quadNode.remove(t), delete t._quadNode);
  }, e.prototype.inRoot = function(t) {
    return t[0].length > 1 || t[1].length > 1;
  }, e.prototype.getSectors = function(t) {
    for (var r = t.bottomRight(), i = Math.floor(r.x / k), s = Math.floor(r.y / k), a = [[], []], h = Math.floor(t.origin.x / k); h <= i; h++)
      a[0].push(h);
    for (var p = Math.floor(t.origin.y / k); p <= s; p++)
      a[1].push(p);
    return a;
  }, e;
}(S);
function Ri(o, e) {
  return o._zIndex < e._zIndex ? 1 : o._zIndex > e._zIndex ? -1 : 0;
}
const qe = ki;
var j = function(e) {
  e.bind("mouseenter", this._mouseenter.bind(this)), e.bind("mouseleave", this._mouseleave.bind(this)), this.element = e.element;
};
j.prototype.clear = function() {
  this._resetCursor();
};
j.prototype.destroy = function() {
  this._resetCursor(), delete this.element;
};
j.prototype._mouseenter = function(e) {
  var n = this._shapeCursor(e);
  n ? (this._current || (this._defaultCursor = this._getCursor()), this._setCursor(n)) : this._resetCursor();
};
j.prototype._mouseleave = function() {
  this._resetCursor();
};
j.prototype._shapeCursor = function(e) {
  for (var n = e.element; n && !d(n.options.cursor); )
    n = n.parent;
  if (n)
    return n.options.cursor;
};
j.prototype._getCursor = function() {
  if (this.element)
    return this.element.style.cursor;
};
j.prototype._setCursor = function(e) {
  this.element && (this.element.style.cursor = e, this._current = e);
};
j.prototype._resetCursor = function() {
  this._current && (this._setCursor(this._defaultCursor || ""), delete this._current);
};
const $i = j;
function Pi(o, e) {
  for (var n = 0; n < e.length; n++) {
    var t = e[n], r = Jt(t.color());
    r.a *= t.opacity(), o.addColorStop(t.offset(), r.toCssRgba());
  }
}
var Ii = function(o) {
  function e() {
    o.apply(this, arguments);
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.renderTo = function(t) {
    t.save(), this.setTransform(t), this.setClip(t), this.setOpacity(t), t.beginPath(), this.renderPoints(t, this.srcElement), this.setLineDash(t), this.setLineCap(t), this.setLineJoin(t), this.setFill(t), this.setStroke(t), t.restore();
  }, e.prototype.setFill = function(t) {
    var r = this.srcElement.options.fill, i = !1;
    return r && (r.nodeType === "Gradient" ? (this.setGradientFill(t, r), i = !0) : N(r.color) || (t.fillStyle = r.color, t.save(), this.globalAlpha(t, r.opacity), t.fill(), t.restore(), i = !0)), i;
  }, e.prototype.setGradientFill = function(t, r) {
    var i = this.srcElement.rawBBox(), s;
    if (r instanceof gr) {
      var a = r.start(), h = r.end();
      s = t.createLinearGradient(a.x, a.y, h.x, h.y);
    } else if (r instanceof _r) {
      var p = r.center();
      s = t.createRadialGradient(p.x, p.y, 0, p.x, p.y, r.radius());
    }
    Pi(s, r.stops), t.save(), r.userSpace() || t.transform(i.width(), 0, 0, i.height(), i.origin.x, i.origin.y), t.fillStyle = s, t.fill(), t.restore();
  }, e.prototype.setStroke = function(t) {
    var r = this.srcElement.options.stroke;
    if (r && !N(r.color) && r.width > 0)
      return t.strokeStyle = r.color, t.lineWidth = te(r.width, 1), t.save(), this.globalAlpha(t, r.opacity), t.stroke(), t.restore(), !0;
  }, e.prototype.dashType = function() {
    var t = this.srcElement.options.stroke;
    if (t && t.dashType)
      return t.dashType.toLowerCase();
  }, e.prototype.setLineDash = function(t) {
    var r = this.dashType();
    if (r && r !== Wt) {
      var i = Ar[r];
      t.setLineDash ? t.setLineDash(i) : (t.mozDash = i, t.webkitLineDash = i);
    }
  }, e.prototype.setLineCap = function(t) {
    var r = this.dashType(), i = this.srcElement.options.stroke;
    r && r !== Wt ? t.lineCap = Or : i && i.lineCap && (t.lineCap = i.lineCap);
  }, e.prototype.setLineJoin = function(t) {
    var r = this.srcElement.options.stroke;
    r && r.lineJoin && (t.lineJoin = r.lineJoin);
  }, e.prototype.renderPoints = function(t, r) {
    Rt(t, r);
  }, e;
}(Mr);
const Y = Ii;
var Li = function(o) {
  function e() {
    o.apply(this, arguments);
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.renderPoints = function(t) {
    var r = this.srcElement.toPath();
    Rt(t, r);
  }, e;
}(Y);
const Di = Li;
var ji = function(o) {
  function e() {
    o.apply(this, arguments);
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.renderPoints = function(t) {
    var r = this.srcElement.geometry(), i = r.center, s = r.radius;
    t.arc(i.x, i.y, s, 0, Math.PI * 2);
  }, e;
}(Y);
const zi = ji;
var Fi = function(o) {
  function e(n, t) {
    o.call(this, n), this.onLoad = this.onLoad.bind(this), this.onError = this.onError.bind(this), this.loading = wt();
    var r = this.img = new Image(), i = n.src();
    t && !/^data:/i.test(i) && (r.crossOrigin = t), i && (r.src = i), r.complete ? this.onLoad() : (r.onload = this.onLoad, r.onerror = this.onError);
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.renderTo = function(t) {
    this.loading.state() === "resolved" && (t.save(), this.setTransform(t), this.setClip(t), this.drawImage(t), t.restore());
  }, e.prototype.optionsChange = function(t) {
    t.field === "src" ? (this.loading = wt(), this.img.src = this.srcElement.src()) : o.prototype.optionsChange.call(this, t);
  }, e.prototype.onLoad = function() {
    this.loading.resolve(), this.invalidate();
  }, e.prototype.onError = function() {
    this.loading.reject(new Error(
      "Unable to load image '" + this.img.src + "'. Check for connectivity and verify CORS headers."
    ));
  }, e.prototype.drawImage = function(t) {
    var r = this.srcElement.rect(), i = r.topLeft();
    t.drawImage(
      this.img,
      i.x,
      i.y,
      r.width(),
      r.height()
    );
  }, e;
}(Y);
const Gi = Fi;
var qi = function(o) {
  function e() {
    o.apply(this, arguments);
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.renderPoints = function(t) {
    for (var r = this.srcElement.paths, i = 0; i < r.length; i++)
      Rt(t, r[i]);
  }, e;
}(Y);
const Bi = qi;
var Hi = function(o) {
  function e() {
    o.apply(this, arguments);
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.renderPoints = function(t) {
    var r = this.srcElement.geometry(), i = r.cornerRadius, s = i[0], a = i[1];
    if (s === 0 && a === 0) {
      var h = r.origin, p = r.size;
      t.rect(h.x, h.y, p.width, p.height);
    } else
      o.prototype.renderPoints.call(this, t, yr.fromRect(r));
  }, e;
}(Y);
const Ni = Hi;
var Vi = function(o) {
  function e() {
    o.apply(this, arguments);
  }
  return o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e, e.prototype.renderTo = function(t) {
    var r = this.srcElement, i = r.position(), s = r.measure();
    t.save(), this.setTransform(t), this.setClip(t), this.setOpacity(t), t.beginPath(), t.font = r.options.font, t.textAlign = "left", this.setFill(t) && t.fillText(r.content(), i.x, i.y + s.baseline), this.setStroke(t) && (this.setLineDash(t), t.strokeText(r.content(), i.x, i.y + s.baseline)), t.restore();
  }, e;
}(Y);
const Ui = Vi;
D.Arc = Di;
D.Circle = zi;
D.Group = Er;
D.Image = Gi;
D.MultiPath = Bi;
D.Path = Y;
D.Rect = Ni;
D.Text = Ui;
var Xi = function(o) {
  function e(t, r) {
    o.call(this, t, r), this.element.innerHTML = this._template(this);
    var i = this.element.firstElementChild;
    i.style.width = "100%", i.style.height = "100%";
    var s = et(t);
    i.width = s.width, i.height = s.height, this._rootElement = i, this._root = new Si(i, s), this._mouseTrackHandler = this._trackMouse.bind(this), ee(this.element, {
      click: this._mouseTrackHandler,
      mousemove: this._mouseTrackHandler
    });
  }
  o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e;
  var n = { type: { configurable: !0 } };
  return n.type.get = function() {
    return "canvas";
  }, e.prototype.destroy = function() {
    o.prototype.destroy.call(this), this._root && (this._root.destroy(), this._root = null), this._searchTree && (this._searchTree.clear(), delete this._searchTree), this._cursor && (this._cursor.destroy(), delete this._cursor), re(this.element, {
      click: this._mouseTrackHandler,
      mousemove: this._mouseTrackHandler
    });
  }, e.prototype.draw = function(r) {
    o.prototype.draw.call(this, r), this._root.load([r], void 0, this.options.cors), this._searchTree && this._searchTree.add([r]);
  }, e.prototype.clear = function() {
    o.prototype.clear.call(this), this._root.clear(), this._searchTree && this._searchTree.clear(), this._cursor && this._cursor.clear();
  }, e.prototype.eventTarget = function(r) {
    if (this._searchTree) {
      var i = this._surfacePoint(r), s = this._searchTree.pointShape(i);
      return s;
    }
  }, e.prototype.image = function() {
    var r = this, i = r._root, s = r._rootElement, a = [];
    i.traverse(function(c) {
      c.loading && a.push(c.loading);
    });
    var h = wt(), p = function() {
      i._invalidate({ fixedScale: !0 });
      try {
        var c = s.toDataURL();
        h.resolve(c);
      } catch (u) {
        h.reject(u);
      }
    };
    return Xe(a).then(p, p), h;
  }, e.prototype.suspendTracking = function() {
    o.prototype.suspendTracking.call(this), this._searchTree && (this._searchTree.clear(), delete this._searchTree);
  }, e.prototype.resumeTracking = function() {
    if (o.prototype.resumeTracking.call(this), !this._searchTree) {
      this._searchTree = new qe();
      for (var r = this._root.childNodes, i = [], s = 0; s < r.length; s++)
        i.push(r[s].srcElement);
      this._searchTree.add(i);
    }
  }, e.prototype._resize = function() {
    this._rootElement.width = this._size.width, this._rootElement.height = this._size.height, this._root.size = this._size, this._root.invalidate();
  }, e.prototype._template = function() {
    return "<canvas></canvas>";
  }, e.prototype._enableTracking = function() {
    this._searchTree = new qe(), this._cursor = new $i(this), o.prototype._enableTracking.call(this);
  }, e.prototype._trackMouse = function(r) {
    if (!this._suspendedTracking) {
      var i = this.eventTarget(r);
      if (r.type !== "click") {
        var s = this._currentShape;
        s && s !== i && this.trigger("mouseleave", {
          element: s,
          originalEvent: r,
          type: "mouseleave"
        }), i && s !== i && this.trigger("mouseenter", {
          element: i,
          originalEvent: r,
          type: "mouseenter"
        }), this.trigger("mousemove", {
          element: i,
          originalEvent: r,
          type: "mousemove"
        }), this._currentShape = i;
      } else
        i && this.trigger("click", {
          element: i,
          originalEvent: r,
          type: "click"
        });
    }
  }, Object.defineProperties(e.prototype, n), e;
}(ae);
const Yi = Xi;
var jt, zt, Rr = function() {
  return typeof document < "u";
}, Wi = function() {
  return Rr() && document.createElement("canvas").getContext;
}, Zi = function() {
  return Rr() && document.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#BasicStructure", "1.1");
}, Ji = function(o) {
  function e() {
    o.call(this), this._items = [{
      name: "svg",
      type: _i
    }, {
      name: "canvas",
      type: Yi
    }];
  }
  o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e;
  var n = { support: { configurable: !0 }, current: { configurable: !0 } };
  return n.support.get = function() {
    return zt || (zt = {
      canvas: Wi(),
      svg: Zi()
    }), zt;
  }, n.current.get = function() {
    return jt || (jt = new e()), jt;
  }, e.prototype.create = function(r, i) {
    var s = this._items, a = s[0];
    if (i && i.type) {
      for (var h = i.type.toLowerCase(), p = 0; p < s.length; p++)
        if (s[p].name === h) {
          a = s[p];
          break;
        }
    }
    if (a)
      return new a.type(r, i);
    Xr(
      `Warning: Unable to create Kendo UI Drawing Surface. Possible causes:
- The browser does not support SVG and Canvas. User agent: ` + navigator.userAgent
    );
  }, Object.defineProperties(e, n), e;
}(S);
const Be = Ji;
var Ki = function(o) {
  function e() {
    o.apply(this, arguments);
  }
  o && (e.__proto__ = o), e.prototype = Object.create(o && o.prototype), e.prototype.constructor = e;
  var n = { support: { configurable: !0 } };
  return n.support.get = function() {
    return Be.support;
  }, e.create = function(r, i) {
    return Be.current.create(r, i);
  }, Object.defineProperties(e, n), e;
}(ae);
const os = Ki;
export {
  z as A,
  Jr as B,
  S as C,
  ts as D,
  ot as E,
  es as F,
  dr as G,
  E as H,
  ns as I,
  an as J,
  wt as K,
  gr as L,
  yo as M,
  mr as N,
  hn as O,
  y as P,
  rn as Q,
  C as R,
  Yi as S,
  Dn as a,
  dn as b,
  ie as c,
  d,
  Mn as e,
  P as f,
  yr as g,
  os as h,
  Jt as i,
  Qi as j,
  we as k,
  gt as l,
  nr as m,
  qt as n,
  qr as o,
  rr as p,
  Ht as q,
  $ as r,
  m as s,
  K as t,
  rs as u,
  bt as v,
  oe as w,
  Xr as x,
  T as y,
  _r as z
};
